import type { Translations } from "./types";

export const ru: Translations = {
  // Common
  save: "Сохранить",
  cancel: "Отмена",
  delete: "Удалить",
  loading: "Загрузка...",
  back: "Назад",
  search: "Поиск",
  close: "Закрыть",
  confirm: "Подтвердить",
  edit: "Редактировать",
  create: "Создать",
  copy: "Копировать",
  copied: "Скопировано",
  download: "Скачать",
  upload: "Загрузить",
  settings: "Настройки",
  profile: "Профиль",
  logout: "Выйти",
  login: "Войти",
  signup: "Регистрация",

  // Navigation
  nav_home: "Главная",
  nav_explore: "Обзор",
  nav_community: "Сообщество",
  nav_messages: "Сообщения",
  nav_settings: "Настройки",
  nav_profile: "Профиль",

  // Settings - Appearance
  settings_appearance: "Внешний вид",
  settings_appearance_desc: "Настройте внешний вид интерфейса.",
  settings_theme: "Тема",
  settings_theme_desc: "Выберите светлую или тёмную тему интерфейса.",
  settings_theme_light: "Светлая",
  settings_theme_light_desc: "Тёплый пергамент",
  settings_theme_dark: "Тёмная",
  settings_theme_dark_desc: "Тёмное подземелье",
  settings_theme_system: "Системная",
  settings_theme_system_desc: "Как на устройстве",
  settings_language: "Язык",
  settings_language_desc: "Выберите предпочитаемый язык интерфейса.",
  locale_auto_detect: "Авто (определить)",
  settings_login_bg: "Фон входа",
  settings_login_bg_desc: "Установите пользовательское фоновое изображение для страницы входа и регистрации.",
  settings_login_bg_url_placeholder: "https://example.com/background.jpg",
  settings_login_bg_hint: "Вставьте URL фонового изображения. Оставьте пустым для значения по умолчанию.",

  // Settings - AI
  settings_ai: "Провайдер ИИ",
  settings_ai_desc: "Настройте модели ИИ, API-ключи и инструменты веб-исследований.",
  settings_provider: "Провайдер",
  settings_provider_desc: "Выберите встроенный Lovable AI или свой собственный ключ Gemini API.",
  settings_use_own_key: "Использовать свой ключ Gemini API",
  settings_using_own_key: "Используется ваш личный ключ Gemini API",
  settings_using_lovable: "Используется встроенный Lovable AI (рекомендуется)",
  settings_lovable_ready: "✨ Lovable AI готов к использованию — настройка не требуется! Поддерживает модели Gemini и GPT.",
  settings_test_connection: "Тест соединения",
  settings_test_key: "Проверить API-ключ",
  settings_test_lovable: "Проверить Lovable AI",
  settings_testing: "Проверка...",

  // Settings - Voice
  settings_voice: "Голос",
  settings_voice_desc: "Настройте провайдеры и голоса для синтеза речи.",
  settings_tts_provider: "Провайдер синтеза речи",
  settings_tts_provider_desc: "Выберите движок TTS для воспроизведения озвучки.",
  settings_default_voice: "Голос рассказчика по умолчанию",
  settings_available_voices: "Доступные голоса",

  // Settings - Credits
  settings_credits: "Кредиты",
  settings_credits_desc: "Ваш кошелёк, реферальная программа и цены на кредиты.",

  // Settings - Analytics
  settings_analytics: "Аналитика",
  settings_analytics_desc: "Метрики использования ИИ и журнал активности.",

  // Settings - Tools
  settings_tools: "Инструменты и диагностика",
  settings_tools_desc: "Панели тестирования и диагностические наборы.",

  // Settings tabs
  tab_appearance: "Внешний вид",
  tab_ai_provider: "Провайдер ИИ",
  tab_credits: "Кредиты",
  tab_voice: "Голос",
  tab_music_library: "Музыкальная библиотека",
  tab_analytics: "Аналитика",
  tab_error_logs: "Журнал ошибок",
  tab_tools: "Инструменты",

  // Profile
  profile_title: "Профиль",
  profile_display_name: "Отображаемое имя",
  profile_email: "Эл. почта",
  profile_bio: "О себе",
  profile_signature: "Подпись на форуме",
  profile_public: "Публичный профиль",
  profile_avatar: "Аватар",
  profile_change_password: "Изменить пароль",
  profile_current_password: "Текущий пароль",
  profile_new_password: "Новый пароль",
  profile_confirm_password: "Подтвердите новый пароль",
  profile_update: "Обновить профиль",
  profile_friends: "Друзья",
  profile_delete_account: "Удалить аккаунт",
  profile_delete_confirm: "Вы уверены, что хотите удалить свой аккаунт? Это действие нельзя отменить.",

  // Dashboard
  dashboard_worlds: "Миры",
  dashboard_adventures: "Приключения",
  dashboard_create_world: "Создать мир",
  dashboard_no_worlds: "Миров пока нет",
  dashboard_no_adventures: "Приключений пока нет",

  // Play
  play_your_turn: "Ваш ход",
  play_send: "Отправить",
  play_type_action: "Что вы делаете?",

  // World Builder
  world_builder: "Конструктор миров",
  world_entities: "Сущности",
  world_plots: "Сюжеты",
  world_mechanics: "Механики",
  world_scenarios: "Сценарии",

  // Misc
  no_results: "Результатов не найдено",
  error_occurred: "Произошла ошибка",
  success: "Успешно",

  // ── Auth ──
  auth_sign_in: "Войти",
  auth_sign_up: "Встать в очередь",
  auth_signing_in: "Вход…",
  auth_signing_up: "Присоединение к списку…",
  auth_sign_in_subtitle: "Войдите, чтобы продолжить приключение",
  auth_sign_up_subtitle: "Встаньте в очередь закрытой ��еты — мы отправим письмо, когда подойдёт ваша очередь",
  auth_reset_password: "Сброс пароля",
  auth_reset_subtitle: "Введите адрес эл. почты, и мы отправим ссылку для сброса",
  auth_forgot_password: "Забыли пароль?",
  auth_send_reset_link: "Отправить ссылку для сброса",
  auth_sending: "Отправка…",
  auth_no_account: "Нет аккаунта? Встаньте в очередь",
  auth_has_account: "Уже есть аккаунт? Войти",
  auth_back_to_sign_in: "Вернуться ко входу",
  auth_email: "Эл. почта",
  auth_password: "Пароль",
  auth_display_name: "Отображаемое имя",
  auth_email_placeholder: "you@example.com",
  auth_password_placeholder: "••••••••",
  auth_password_signup_placeholder: "Минимум 6 символов",
  auth_password_min: "Минимум 6 символов",
  auth_name_placeholder: "Ваше имя",
  auth_referral_bonus: "Вас пригласили! Ваша заявка будет рассмотрена в приоритете",
  auth_daily_bonus: "Ежедневный бонус: +{credits} кредитов!",
  auth_welcome_back: "С возвращением!",
  auth_check_email: "Проверьте почту, чтобы подтвердить место в очереди!",
  auth_reset_sent: "Ссылка для сброса пароля отправлена! Проверьте почту.",
  auth_enter_email: "Пожалуйста, введите адрес эл. почты.",

  // ── AppHeader / Nav ──
  nav_worlds: "Миры",
  nav_about: "О проекте",
  nav_roadmap: "Дорожная карта",
  nav_pricing: "Тарифы",
  nav_contact: "Контакты",
  nav_forums: "Форумы",
  nav_users: "Пользователи",
  nav_sign_in_up: "Войти / В очередь",
  nav_guest_browsing: "Вы просматриваете как гость",
  nav_set_display_name: "Укажите имя",
  nav_user_management: "Управление пользователями",
  nav_sign_out: "Выйти",
  nav_active_tasks: "Активные задачи",
  nav_clear: "Очистить",
  gh_open_menu: "Открыть меню",
  gh_menu: "Меню",
  gh_account: "Аккаунт",
  gh_credits: "Кредиты",
  nav_your_credits: "Ваши кредиты",
  nav_no_credits: "Нет кредитов — все функции ИИ отключены",
  nav_low_credits: "Мало кредитов — создание миров отключено",
  nav_transfers_disabled: "Кредитов менее 100 — переводы отключены",

  // Task phases
  task_searching: "Поиск в интернете",
  task_writing_brief: "Составление описания",
  task_generating: "Генерация изображения",
  task_complete: "Завершено",
  task_failed: "Ошибка",

  // ── Index / Dashboard (extended) ──
  idx_tagline: "Создавайте миры с помощью ИИ, затем играйте в них как текстовые приключения.",
  idx_my_worlds: "Мои миры",
  idx_my_adventures: "Мои приключения",
  idx_public_worlds: "Публичные миры",
  idx_trash: "Корзина",
  idx_new_world: "Новый мир",
  idx_create_new_world: "Создать новый мир",
  idx_manual: "Вручную",
  idx_manual_desc: "Название и описание",
  idx_ai_prompt: "ИИ-промпт",
  idx_ai_prompt_desc: "Опишите, и ИИ построит",
  idx_world_name_placeholder: "Название мира (оставьте пустым для автогенерации)...",
  idx_world_desc_placeholder: "Краткое описание (оставьте пустым для автогенерации)...",
  idx_world_prompt_placeholder: "Опишите мир, который хотите создать... например 'Тёмный фэнтезийный мир в стиле Bloodborne, с элементами космического ужаса и связанными районами города'",
  idx_reference_files: "Справочные файлы (необязательно)",
  idx_terms_title: "⚠️ Условия и отказ от ответственности",
  idx_terms_content_1: "Создавая мир, вы подтверждаете, что владеете или имеете права на все загруженные медиа и контент. Вы принимаете полную ответственность за загружаемые материалы.",
  idx_terms_content_2: "Контент, созданный ИИ (текст, изображения, сценарии), предоставляется «как есть» без гарантий точности, уместности или пригодности. Мы не несём ответственности за результаты ИИ.",
  idx_create_with_ai: "Создать с ИИ",
  idx_create_and_build: "Создать и начать строить",
  idx_no_worlds_hint: "Миров пока нет. Создайте свой первый мир!",
  idx_your_worlds: "Ваши миры",
  idx_shared_with_you: "Доступные вам",
  idx_new_game: "Новая игра",
  idx_join_game: "Присоединиться",
  idx_join_game_title: "Присоединиться к игре",
  idx_join_game_desc: "Введите код приглашения или вставьте ссылку, чтобы присоединиться к многопользовательскому приключению.",
  idx_invite_code_placeholder: "Код приглашения...",
  idx_join: "Вступить",
  idx_joining_adventure: "Присоединяемся к приключению...",
  idx_select_world: "Выберите мир",
  idx_choose_world: "Выберите мир для игры...",
  idx_no_worlds_available: "Нет доступных миров. Сначала создайте мир!",
  idx_select_or_new_adventure: "Продолжите существующее приключение или начните новое.",
  idx_or: "или",
  idx_your_turn: "Ваш ход",
  idx_adventures: "Приключения",
  idx_no_adventures_hint: "Приключений пока нет. Начните новую игру или присоединитесь!",
  idx_trashed_worlds: "Удалённые миры",
  idx_trash_desc: "Удалённые миры хранятся здесь. Восстановите их или удалите навсегда.",
  idx_trash_empty: "Корзина пуста",
  idx_restore: "Восстановить",
  idx_delete_forever: "Удалить навсегда",
  idx_delete_forever_title: "Удалить этот мир навсегда?",
  idx_delete_forever_desc: "и все его сущности, сюжеты, агенты и медиа будут удалены навсегда. Это действие нельзя отменить.",
  idx_no_public_worlds: "Публичных миров пока нет.",
  idx_solo: "Соло",
  idx_joined: "Присоединён",
  idx_yours: "Ваш",
  idx_updated: "Обновлено",
  idx_deleted: "Удалено",
  idx_turn: "Ход",
  idx_drop_files: "Перетащите файлы сюда или нажмите кнопку загрузки",
  idx_start_new_game: "Начать новую игру",

  // ── Profile (extended) ──
  profile_account_settings: "Настройки аккаунта",
  profile_account_settings_desc: "Управление профилем и безопасностью",
  profile_info: "Информация о профиле",
  profile_info_desc: "Обновите личные данные",
  profile_achievements: "Достижения",
  profile_avatar_hint: "Загрузите изображение или вставьте прямую ссылку.",
  profile_name_placeholder: "Введите отображаемое имя",
  profile_name_hint: "Так вас будут видеть другие игроки",
  profile_email_readonly: "Эл. почту нельзя изменить",
  profile_bio_placeholder: "Расскажите о себе...",
  profile_avatar_url_placeholder: "https://example.com/avatar.jpg",
  profile_signature_placeholder: "Отображается под вашими сообщениями на форуме...",
  profile_signature_hint: "До 240 символов.",
  profile_public_hint: "Разрешить другим видеть ваш профиль",
  profile_tab_byok: "BYOK",
  profile_secret_mode: "Секретный режим",
  profile_secret_mode_desc: "Скрыть себя от поиска игроков. Существующие друзья всё равно могут вас видеть.",
  profile_save_changes: "Сохранить изменения",
  profile_updating: "Обновление...",
  profile_password_desc: "Обновите пароль аккаунта",
  profile_password_changing: "Изменение...",
  profile_account_actions: "Действия с аккаунтом",
  profile_account_actions_desc: "Управление аккаунтом",
  profile_logout_confirm: "Вы уверены?",
  profile_logout_confirm_desc: "Вы будете выведены из аккаунта.",

  // ── Play ──
  play_what_do_you_do: "Что вы делаете?",
  play_waiting_turn: "Ожидание хода другого игрока...",
  play_debug_log: "Скачать отладочный журнал",
  play_adventure_state: "Состояние приключения",

  // ── World Builder (extended) ──
  wb_title: "Конструктор миров",
  wb_empty_desc: "Опишите концепцию мира, и я создам сущности, локации, персонажей и сюжетные линии.",
  wb_describe_placeholder: "Опишите ваш мир...",
  wb_describe_placeholder_full: "Enter — отправить · Shift+Enter — новая строка · Ctrl+Enter — в очередь",
  wb_shuffle: "Перемешать предложения",
  wb_show_older: "Показать старые",
  wb_queue: "Очередь",
  wb_queue_paused: "Приостановлено",
  wb_send_queue: "Отправить очередь",
  wb_resume: "Возобновить",
  wb_pause: "Пауза",
  wb_unpause: "Снять паузу",
  wb_clear: "Очистить",
  wb_stop: "Стоп",
  wb_retry: "Возобновить / Повторить",
  wb_unsaved: "Не сохранено",
  wb_unsaved_title: "Несохранённые изменения",
  wb_unsaved_desc: "У вас есть несохранённые изменения. Сохранить перед выходом?",
  wb_leave_without_saving: "Выйти без сохранения",
  wb_save_and_leave: "Сохранить и выйти",
  wb_read_only: "Только чтение",
  wb_update: "Обновление",
  wb_full_access: "Полный доступ",
  wb_debug_dump: "Скачать отладочный дамп",
  wb_panel_title: "Панель конструктора миров",

  // ── World Builder Panel (CreationPanel) ──
  wb_entities: "сущностей",
  wb_save: "Сохранить",
  wb_saved: "Сохранено",
  wb_play: "Играть",
  wb_play_adventure: "Играть в приключение",
  wb_ui_version_label: "Интерфейс билдера",
  wb_ui_version_desc: "Выберите, какой интерфейс конструктора миров использовать.",
  wb_ui_version_v1: "V1",
  wb_ui_version_v2: "V2",
  flow_version_label: "Движок Flow",
  flow_version_desc: "V2 использует конвейер Agents SDK (экспериментально).",
  flow_version_v1: "V1 — Классический",
  flow_version_v2: "V2 — SDK",
  wb_v2_canvas_hint: "Холст V2 — в разработке",
  wb_v2_empty: "Пока нет сущностей — попросите агента построить мир",
  wb_v2_actions: "Действия",
  wb_v2_action_add: "Добавить",
  wb_v2_action_generate: "Сгенерировать",
  wb_v2_action_layout: "Макет",
  wb_v2_action_settings: "Настройки",
  wb_v2_coming_soon: "Скоро",
  wb_loading_adventures: "Загрузка приключений...",
  wb_continue_playing: "Продолжить игру",
  wb_or_start_new: "или начать новое",
  wb_adventure_name: "Название приключения...",
  wb_multiplayer: "Мультиплеер",
  wb_multiplayer_desc: "Пригласите других",
  wb_turn_mode: "Режим ходов",
  wb_free_form: "Свободный",
  wb_round_robin: "По кругу",
  wb_create_mp: "Создать многопользовательское приключение",
  wb_begin_new: "Начать новое приключение",
  wb_share: "Поделиться",
  wb_world_banner: "Баннер мира",
  wb_trash: "Корзина",
  wb_section_build: "Сборка",
  wb_section_statistics: "Статистика",
  wb_section_feedback: "Отзывы",
  wb_section_publishing: "Публикация",
  wb_group_general: "Общее",
  wb_group_data: "Данные",
  wb_group_media: "Медиа",
  wb_group_engine: "Движок",
  wb_group_agents: "Агенты",
  wb_tab_world_gen: "Генерация мира",
  wb_tab_checklist: "Чек-лист",
  wb_tab_locations: "Локации",
  wb_tab_map: "Карта",
  wb_tab_entities: "Сущности",
  wb_tab_plot: "Сюжет",
  wb_tab_context: "Контекст",
  wb_tab_media: "Медиатека",
  wb_tab_voice: "Настройки голоса",
  wb_tab_music: "Музыка",
  wb_tab_mechanics: "Механики",
  wb_tab_scenarios: "Сценарии",
  wb_tab_players: "Игроки",
  wb_tab_agents: "Библиотека агентов",
  wb_tab_chats: "Чаты",
  wb_tab_about: "О мире",
  wb_tab_privacy: "Приватность и доступ",
  wb_tab_actions: "Действия",
  wb_tab_design_issues: "Обратная связь",
  wb_quick_create: "Создать",
  wb_describe_create: "Опишите, что создать...",
  wb_send: "Отправить",
  wb_tab_promotion: "Продвижение",
  wb_section_instances: "Активные игры",
  wb_group_general_desc: "Идентичность мира и настройки",
  wb_group_data_desc: "Контент и лор мира",
  wb_group_media_desc: "Визуальные и аудио ресурсы",
  wb_group_engine_desc: "Правила, сценарии и игроки",
  wb_group_agents_desc: "ИИ-агенты и чаты",
  wb_quick_new_entity: "Создать новую интересную сущность для мира",
  wb_quick_new_plot: "Создать новый сюжетный крючок или арку для этого мира",
  wb_quick_new_agent: "Создать нового ИИ-агента для этого мира",
  wb_quick_new_location: "Создать новую локацию для этого мира",

  // ── World AI Provider ──
  ai_title: "Провайдер ИИ",
  ai_desc: "Настройте провайдера ИИ и модель для этого мира. Каждый мир может использовать своего провайдера.",
  ai_membership_required: "Требуется подписка",
  ai_membership_desc: "Настройка провайдера ИИ для каждого мира требует активной подписки с настроенным BYOK (принесите свой ключ). Перейдите в Профиль → API-ключи для настройки.",
  ai_use_custom: "Использовать свой ИИ для этого мира",
  ai_use_custom_desc: "Заменить стандартный ИИ платформы на вашего провайдера BYOK для всех ИИ-вызовов в этом мире.",
  ai_no_accounts: "Нет текстовых аккаунтов",
  ai_no_accounts_desc: "Вы ещё не настроили текстовые аккаунты BYOK. Перейдите в Профиль → API-ключи → вкладка Текст, чтобы добавить.",
  ai_account_label: "Аккаунт ИИ",
  ai_select_account: "Выберите аккаунт",
  ai_default_account: "BYOK-аккаунт по умолчанию",
  ai_account_hint: "Выберите текстовый аккаунт BYOK для ИИ-вызовов в этом мире. \"По умолчанию\" использует аккаунт, отмеченный как основной в вашем профиле.",
  ai_save_config: "Сохранить настройки ИИ",
  ai_config_saved: "Настройки ИИ сохранены",
  ai_save_failed: "Ошибка сохранения: ",
  ai_verified: "проверен",
  ai_default_badge: "по умолчанию",

  // ── Plot Panel ──
  plot_cat_main_quest: "Основной квест",
  plot_cat_side_quest: "Побочный квест",
  plot_cat_plot_hook: "Сюжетный крючок",
  plot_cat_conflict: "Конфликт",
  plot_cat_key_moment: "Ключевой момент",
  plot_cat_event: "Событие",
  plot_cat_development: "Развитие",
  plot_cat_lore: "Лор",
  plot_cat_completion: "Завершение",
  plot_cat_note: "Заметка",
  plot_tab_quests: "Квесты",
  plot_tab_quests_desc: "Основные и побочные квесты с целями и привязкой к сценариям.",
  plot_tab_story: "Сюжет",
  plot_tab_story_desc: "Ключевые моменты, события, сюжетные крючки, конфликты и лор.",
  plot_tab_conditions: "Условия",
  plot_tab_conditions_desc: "Условия победы, поражения и завершения.",
  plot_relevance_critical: "Критично",
  plot_relevance_high: "Высокая",
  plot_relevance_medium: "Средняя",
  plot_relevance_low: "Низкая",
  plot_relevance_background: "Фон",
  plot_objectives: "Цели",
  plot_add_objective: "Добавить цель...",
  plot_entry_title: "Название записи...",
  plot_add_entry: "Добавить запись",
  plot_no_quests: "Квестов пока нет",
  plot_no_story: "Сюжетных записей пока нет",
  plot_no_conditions: "Условий завершения пока нет",
  plot_add_first: "Добавить первую запись",
  plot_title_placeholder: "Название...",
  plot_describe_placeholder: "Опишите этот элемент сюжета...",
  plot_category: "Категория",
  plot_relevance: "Релевантность",
  plot_linked_scenario: "Связанный сценарий",
  plot_none: "Нет",
  plot_no_description: "Описание отсутствует",
  plot_all_scenarios: "Все сценарии",
  plot_aria_filter_scenario: "Фильтр по сценарию",
  plot_aria_new_entry_category: "Категория новой записи",
  plot_aria_edit_category: "Изменить категорию",
  plot_aria_linked_scenario: "Связанный сценарий",
  plot_merge: "Объединить",
  plot_selected: "выбрано",
  plot_select_min_2: "Выберите минимум 2 записи для объединения",
  plot_merge_failed: "Ошибка объединения",
  plot_deleted: "Запись удалена",
  plot_delete_failed: "Ошибка удаления",
  plot_save_failed: "Ошибка сохранения",
  plot_add_failed: "Ошибка добавления записи",

  // ── Design Issues Panel ──
  di_loading: "Загрузка отзывов по дизайну…",
  di_no_issues: "Проблемы дизайна не обнаружены",
  di_no_issues_desc: "Проблемы собираются во время игры и отображаются здесь для исправления.",
  di_title: "Проблемы дизайна",
  di_open: "открытых",
  di_desc: "Проблемы, обнаруженные во время игры, требующие вашего внимания в редакторе мира.",
  di_cat_entity: "Сущность",
  di_cat_mechanic: "Механика",
  di_cat_prompt: "Промпт",
  di_cat_tool: "Инструмент",
  di_cat_content: "Контент",
  di_dismiss: "Скрыть",
  di_occurrences: "повторений",
  di_first_seen_turn: "Впервые: ход",
  di_source_ai: "Обнаружено ИИ",
  di_source_rule: "Обнаружено правилом",

  // ── Privacy Section (extras) ──
  priv_confidential: "Конфиденциальный режим",
  priv_confidential_desc: "Ограничить этот мир только приглашёнными пользователями. ИИ платформы отключён — будет использоваться только ваш внешний провайдер ИИ.",
  priv_confidential_active: "Конфиденциальный режим активен.",
  priv_confidential_active_desc: "Этот мир скрыт от публичного обнаружения, доступен только приглашённым и использует только ваш настроенный внешний ИИ-провайдер (BYOK / Custom AI). Публикация, публичный доступ и клонирование отключены.",
  priv_locked_by_confidential: "Заблокировано конфиденциальным режимом",
  priv_share_link: "Ссылка для совместного доступа",
  priv_share_link_desc: "Поделитесь этой ссылкой, чтобы любой мог просмотреть ваш мир и начать играть.",
  priv_share_copied: "Ссылка скопирована!",

  // ── Generation Section (extras) ──
  gen_conservative: "Консервативный",
  gen_balanced: "Сбалансированный",
  gen_aggressive: "Агрессивный",
  gen_conservative_desc: "Минимальная автогенерация. Создаёт только то, что строго необходимо миру.",
  gen_balanced_desc: "Умеренная генерация. Создаёт сущности и лор по мере необходимости.",
  gen_aggressive_desc: "Максимальное построение мира. Обильно создаёт сущности, лор, изображения.",
  gen_conservative_detail: "Новые сущности только при явном упоминании. Без изображений сцен, без спекулятивного лора.",
  gen_balanced_detail: "Автосоздание NPC и локаций при упоминании. Периодические изображения сцен.",
  gen_aggressive_detail: "Проактивное создание NPC/локаций/сюжетов. Автоизображения сцен. Автообслуживание кодекса.",

  // ── Context Panel ──
  ctx_description: "Описание",
  ctx_click_to_edit: "Нажмите для редактирования",
  ctx_click_to_add: "Нажмите, чтобы добавить описание, или позвольте ИИ создать его.",
  ctx_media_generation: "Генерация медиа",
  ctx_allow_ingame: "Разрешить генерацию в игре",
  ctx_allow_ingame_desc: "При включении игроки могут создавать портреты персонажей во время игры. При отключении генерация медиа ограничена Конструктором миров.",
  ctx_media_enabled: "Генерация медиа в игре включена",
  ctx_media_disabled: "Генерация медиа в игре отключена",
  ctx_update_failed: "Не удалось обновить настройку",

  // ── Scenarios Panel ──
  scn_desc: "Определите стартовые сценарии — шаблоны, которые формируют начало приключений.",
  scn_new: "Новый сценарий",
  scn_no_scenarios: "Сценариев пока нет.",
  scn_no_scenarios_desc: "Создайте сценарии, чтобы дать игрокам структурированные точки старта. Без сценариев приключения начинаются в свободной форме.",
  scn_create_first: "Создать первый сценарий",
  scn_needs_title: "Сценарию нужно название",
  scn_updated: "Сценарий обновлён",
  scn_created: "Сценарий создан",
  scn_default_set: "Сценарий по умолчанию установлен",
  scn_deleted: "Сценарий перемещён в корзину",
  scn_delete_failed: "Ошибка удаления сценария",
  scn_difficulty_easy: "Лёгкий",
  scn_difficulty_normal: "Обычный",
  scn_difficulty_hard: "Сложный",
  scn_difficulty_brutal: "Жестокий",
  scn_difficulty_adaptive: "Адаптивный",
  scn_img_saved: "Изображение сценария сохранено",
  scn_img_save_failed: "Не удалось сохранить изображение",
  scn_img_removed: "Изображение сценария удалено",
  scn_img_remove_failed: "Не удалось удалить изображение",

  // ── About Section (editor) ──
  about_preview_page: "Предпросмотр",
  about_click_change_icon: "Нажмите для смены иконки",
  about_click_set: "Нажмите для установки",
  about_world_name_hint: "Отображаемое имя для игроков и на публичной странице.",
  about_world_id_copied: "ID мира скопирован",
  about_anonymous: "Аноним",

  // ── Actions Section (editor) ──
  act_world_deleted: "Мир удалён",
  act_delete_failed: "Ошибка удаления",
  act_clone_placeholder: "Мой клонированный мир",
  act_clone_failed: "Ошибка клонирования",
  act_cloned: "Мир успешно клонирован!",

  // ── Gameplay panels ──
  play_auto: "Авто",
  play_manual: "Ручной",
  play_no_response: "⚠ Ответ не получен",
  play_send_again: "Отправить снова",
  play_may_not_received: "⚠ Возможно, не получено",
  play_you: "Вы",
  play_turn: "Ход",
  play_active: "Активен",
  play_switch: "Переключить",
  play_no_pov: "Персонажи POV ещё не зарегистрированы. Рассказчик добавит их по мере развития истории.",
  play_no_party: "Нет участников группы",
  play_party: "Группа",
  play_waiting_char: "Ожидание создания персонажа...",
  play_inner_voice: "Внутренний голос",
  play_thoughts_log: "Журнал",
  play_observing: "молча наблюдает…",
  play_awaiting_thoughts: "Ожидание мыслей…",

  // ── Decision Journal ──
  play_decision_journal: "Журнал решений",
  play_pending_consequences: "ожидающих последствий",
  play_choices_pending: "Некоторые из ваших решений ещё не полностью реализовались.",
  play_immediate: "Немедленные",
  play_ripple_effects: "Волновые эффекты",

  // ── Encounter / Events ──
  play_no_events: "Событий пока нет",
  play_no_events_desc: "События, встречи и мировые новости появятся здесь по мере развития истории.",
  play_events_world: "События и мир",
  play_active_events: "Активные события",
  play_pending_ripples: "Ожидающие волны",

  // ── Lore Codex ──
  play_codex_characters: "Персонажи",
  play_codex_locations: "Локации",
  play_codex_quests: "Квесты и цели",
  play_codex_factions: "Фракции и организации",
  play_codex_items: "Предметы и артефакты",
  play_codex_lore: "Знания и лор",

  // ── Research Panel ──
  play_research_tree: "Дерево исследований",
  play_research_in_progress: "В процессе",
  play_research_queued: "В очереди",
  play_research_completed: "Завершено",
  play_research_none: "Исследования ещё не начаты",
  play_research_ask: "Спросите о доступных темах исследований",

  // ── Operations Panel ──
  play_ops_overview: "Обзор",
  play_ops_territory: "Территория",
  play_ops_workforce: "Рабочая сила",
  play_ops_resources: "Ресурсы",
  play_ops_unnamed_org: "Организация без названия",

  // ── Org tiers/types/styles ──
  play_tier_street: "Уличный уровень",
  play_tier_established: "Закрепившийся",
  play_tier_major: "Крупный игрок",
  play_tier_dominant: "Доминирующая сила",
  play_tier_undisputed: "Бесспорная власть",
  play_org_criminal: "Преступный синдикат",
  play_org_intelligence: "Разведячейка",
  play_org_corporate: "Корпоративная империя",
  play_org_military: "Военное командование",
  play_org_custom: "Пользовательский",
  play_style_hierarchical: "Иерархический",
  play_style_cell: "Ячеистый",
  play_style_feudal: "Феодальный",

  // ── Item rarity ──
  play_rarity_common: "Обычный",
  play_rarity_uncommon: "Необычный",
  play_rarity_rare: "Редкий",
  play_rarity_epic: "Эпический",
  play_rarity_legendary: "Легендарный",

  // ── Dice Tray ──
  play_quick_rolls: "Быстрые броски",
  play_dice_hint: "Рассказчик определяет кубики, модификаторы и DC",

  // ── Location detail ──
  play_known_details: "Известные детали",
  play_travel_to: "Путешествие к",

  // ── Codex extra ──
  play_codex_empty: "Кодекс пуст",
  play_codex_empty_desc: "Открытия появятся здесь по мере исследования мира — люди, которых вы встретите, места, которые посетите, и знания, которые раскроете.",
  play_codex_title: "Кодекс",
  play_codex_search: "Поиск в кодексе…",
  play_codex_other: "Прочее",

  // ── Encounter extra ──
  play_enc_all: "Все",
  play_enc_encounters: "Встречи",
  play_enc_news: "Новости",
  play_enc_ripples: "Последствия",
  play_enc_no_encounters: "Встреч пока нет",
  play_enc_no_news: "Мировых новостей пока нет",
  play_enc_since_event: "с последнего события",
  play_enc_since_news: "с последних новостей",

  // ── Research extra ──
  play_research_tier: "Уровень",
  play_research_turn_left: "осталось",

  // ── Org / Operations shared ──
  play_org_unnamed: "Безымянная организация",
  play_org_treasury: "Казна",
  play_org_income_turn: "Доход/ход",
  play_org_tier: "Уровень",
  play_org_morale: "Мораль",
  play_org_heat: "Внимание",
  play_org_territories: "Территории",
  play_org_personnel: "Персонал",
  play_org_resources: "Ресурсы",
  play_org_no_territory: "Нет данных о территории. Захватите локации, чтобы строить владения.",
  play_org_no_personnel: "Персонал ещё не набран.",
  play_org_no_resources: "Ресурсы пока не отслеживаются. Они появятся по ходу истории.",
  play_org_controlled: "Под контролем",
  play_org_contested: "Оспаривается",
  play_org_rival_factions: "Враждебные фракции",
  play_org_stockpile: "Запасы",
  play_org_production: "Производство",
  play_org_upkeep: "Содержание",
  play_org_controlled_loc: "Контролируемые локации",
  play_org_no_territory_ctrl: "Контролируемых территорий пока нет",

  // ── Item card ──
  play_item_equipped: "Экипировано",
  play_item_modifiers: "Модификаторы",
  play_item_when_equipped: "(при экипировке)",
  play_item_effects: "Эффекты",
  play_item_durability: "Прочность",
  play_item_charges: "Заряды",
  play_item_weight: "Вес",
  play_item_cursed: "Проклято",
  play_item_quest: "Квестовый предмет",

  // ── Recent thoughts ──
  play_recent_thoughts: "Недавние мысли",

  // ── PlayChatInput extra ──
  play_autoscroll_on: "Автопрокрутка ВКЛ",
  play_autoscroll_off: "Автопрокрутка ВЫКЛ",
  play_debug_downloads: "Отладочные загрузки",
  play_conversation_log: "Журнал разговора",
  play_game_snapshot: "Снимок игры",

  // ── Locations Panel (editor) ──
  loc_open_map_editor: "Открыть редактор карт",
  loc_maps: "Карты",
  loc_no_maps: "Карты ещё не созданы",
  loc_new_map: "Новая карта",
  loc_map_editor: "Редактор карт",

  // ── Play widgets ──
  widget_rest_title: "Отдых и восстановление",
  widget_rest_hit_dice: "Кости хитов",
  widget_rest_last_long: "Последний долгий отдых",
  widget_rest_today: "Сегодня",
  widget_rest_days_ago: "дн. назад",
  widget_rest_short: "Короткий отдых",
  widget_rest_long: "Долгий отдых",
  widget_combat_death_saves: "Спасброски от смерти",
  widget_combat_attack: "Атака",
  widget_combat_defend: "Защита",
  widget_combat_flee: "Побег",
  widget_combat_special: "Особое",
  widget_combat_attack_desc: "Ударить цель",
  widget_combat_defend_desc: "Приготовиться к удару",
  widget_combat_flee_desc: "Попытаться сбежать",
  widget_combat_special_desc: "Использовать способность",
  widget_conditions_title: "Состояния",
  widget_conditions_none: "Нет активных состояний",
  widget_conditions_exhaustion: "Истощение",
  widget_conditions_concentration: "Концентрация",
  widget_conditions_turns_left: "ходов осталось",

  // ── About page ──
  about_hero_title_1: "Каждая история заслуживает",
  about_hero_title_2: "свой игровой движок.",
  about_hero_desc: "Adventure Venture — платформа текстовых приключений на базе ИИ. Вы строите миры, ИИ управляет ими, а ваши решения действительно влияют на всё — даже самые дурацкие.",
  about_hero_desc_em: "Особенно дурацкие.",
  about_hero_cta_dashboard: "В панель управления",
  about_hero_cta_start: "Встать в очередь",
  about_hero_cta_browse: "Смотреть миры",
  about_bottom_title: "Ваш мир ждёт.",
  about_bottom_desc: "Создайте что-то абсурдное. Создайте что-то эпическое. Создайте что-то абсолютно бессмысленное и смотрите, как ИИ пытается это оживить. Мы в вас верим. Наверное.",
  about_badge_worldbuilding: "Создание миров",
  about_badge_gamemaster: "ИИ-мастер игры",
  about_badge_survival: "Выживание и бой",
  about_badge_npcs: "Живые NPC",
  about_badge_timetravel: "Любой жанр. Любой сеттинг.",
  about_badge_multiplayer: "Мультиплеер",
  about_sub_worldbuilding: "Кодекс мира",
  about_sub_gamemaster: "Оркестр повествования",
  about_sub_survival: "Механики, которые кусаются",
  about_sub_npcs: "Двигатель последствий",
  about_sub_timetravel: "Безграничное пространство",
  about_sub_multiplayer: "Совместный хаос",
  about_title_worldbuilding: "Стройте вселенные.\nПрямо с дивана.",
  about_title_gamemaster: "Мастер, который\nникогда не отменяет игру.",
  about_title_survival: "Умирайте красиво.\nСнова и снова.",
  about_title_npcs: "NPC, которые\nпомнят обиды.",
  about_title_timetravel: "Динозавры встречают\nкосмодесантников.",
  about_title_multiplayer: "Разрушайте дружбу.\nВместе.",
  about_desc_worldbuilding_1: "Представьте: вам дали таблицу и сказали «заполни — это вселенная». Примерно это мы и сделали, только таблица думает сама и делает большую часть работы за вас.",
  about_desc_worldbuilding_2: "Опишите мир обычным языком — или загрузите документы с лором — и смотрите, как ИИ заселяет континенты, фракции, NPC с подозрительными биографиями и ту самую таверну, которая есть в каждом фэнтези-мире.",
  about_desc_worldbuilding_3: "Каждая сущность связана с остальными. Сменили имя короля — повстанцам нужны новые плакаты. Кодекс следит за связями, иерархиями и обидами, чтобы вам не приходилось.",
  about_desc_gamemaster_1: "Наш ИИ-мастер — не робот со сценарием, а безумный театральный режиссёр, управляющий реальностью. Он дирижирует армией агентов — рассказчик, NPC, судья боя, хранитель лора — все спорят за кулисами о том, что должно случиться дальше.",
  about_desc_gamemaster_2: "Директор сложности незаметно регулирует уровень вызова. Побеждаете слишком легко? Встречайте засаду. Вас уничтожают? Тот фонтан исцеления всегда тут стоял. Определённо.",
  about_desc_gamemaster_3: "Движок ритма следит за напряжением как сценарист сериала. Тихие моменты нарастают до кульминации. Победы чувствуются заслуженными. Поражения — драматичными. Это не баг — это нарративная структура.",
  about_desc_survival_1: "Бой в стиле D&D с настоящими бросками кубиков, порядком инициативы и тем прекрасным моментом, когда выпадает натуральная единица при попытке произвести впечатление на дракона. Система управляет здоровьем, состояниями, спасбросками и экзистенциальным ужасом от пустых ячеек заклинаний.",
  about_desc_survival_2: "Механики выживания отслеживают голод, жажду, температуру и усталость — ничто не кричит «эпическое приключение» громче, чем варвар с насморком. Создавайте снаряжение, управляйте ресурсами и спорьте с ИИ о подозрительных грибах.",
  about_desc_survival_3: "Экономика, в которой золото действительно важно. Покупайте снаряжение, подкупайте стражу, вкладывайтесь в недвижимость вымышленного королевства. Журнал квестов фиксирует всё: достижения, провалы и всё, что вы предпочитаете забыть.",
  about_desc_npcs_1: "Каждый NPC управляется собственным ИИ-агентом с памятью, мнениями и пугающей склонностью к пассивной агрессии. Обокрали торговца? Он помнит. Помогли фермеру? Он назовёт корову в вашу честь. Предали главу гильдии? Удачи с покупкой зелий.",
  about_desc_npcs_2: "Система репутации отслеживает мнение каждой фракции — и они сплетничают. Ваш статус у воровской гильдии влияет на отношение стражи, что влияет на скидки у торговцев, что влияет на покупку меча для задания воровской гильдии.",
  about_desc_npcs_3: "Система морали не судит — она записывает. Выбор сдвигает мировоззрение героя через действия, а не через меню. Праведников почитают. Злодеев боятся. Морально неоднозначных приглашают на лучшие вечеринки.",
  about_desc_timetravel_1: "Средневековое фэнтези — классика, но что если вашему рыцарю придётся вести переговоры с киберпанк-корпорацией? Что если детектив наткнётся на фейское кольцо? Что если капитан звездолёта разобьётся на планете, работающей на магии?",
  about_desc_timetravel_2: "Движку плевать на границы жанров. Создавайте викторианский стимпанк-детектив. Постапокалиптическое кулинарное шоу. Политический триллер в гномьем парламенте. Фанфик с такой точностью лора, что оригинальные авторы занервничают.",
  about_desc_timetravel_3: "Загрузите исходники — романы, вики, гайды — система впитает всё в Кодекс. Лор вашего мира станет лором ИИ. Он процитирует деталь со страницы 47 так, будто реально прочитал книгу. Потому что прочитал.",
  about_desc_multiplayer_1: "Пригласите друзей и наблюдайте, как идеальное ограбление разваливается, потому что кто-то решил погладить сторожевого пса. Пошаговые ходы, свободный хаос и бой по инициативе — некоторым спорам нужна структура.",
  about_desc_multiplayer_2: "Каждый игрок получает лист персонажа, инвентарь и растущий список сомнительных решений. ИИ следит за репутацией, квестами и тем игроком, который флиртует с каждым NPC без разбора.",
  about_desc_multiplayer_3: "Делитесь мирами с соавторами или публикуйте для сообщества. Ваше викторианское расследование убийства может стать чьей-то комедией. В этом красота хаоса — он совместный.",

  // ── BYOK section keys ──
  about_badge_byok: "Свой ключ",
  about_sub_byok: "Ваши ключи, ваши правила",
  about_title_byok: "Безлимитная игра.\nВаши API-ключи.",
  about_desc_byok_1: "Есть ключ Google Gemini? Аккаунт ElevenLabs? Подключите их и перестаньте смотреть, как утекают кредиты.",
  about_desc_byok_2: "Генерация текста, синтез речи, поиск — используйте свой ключ и платите напрямую. Поиск по Wiki и Fandom по-прежнему стоит кредиты.",
  about_desc_byok_3: "Пользователи BYOK также могут выбирать модель ИИ для каждого агента — хотите, чтобы злодей работал на Pro, а лавочник на Flash Lite? Ваш ключ — ваш выбор.",

  // ── About FAQ section ──
  about_faq_title: "Часто задаваемые вопросы",
  about_faq_q1: "Чем Adventure Venture отличается от AI Dungeon?",
  about_faq_a1: "Главное отличие — архитектурное: Adventure Venture запускает несколько ИИ-агентов одновременно — рассказчика, агентов NPC, судью боя, хранителя лора — вместо одного чатбота, притворяющегося всеми ними. NPC имеют постоянную память между сессиями (не только в рамках одного разговора), и существуют настоящие игровые механики: броски кубиков, системы выживания, экономика, контроль территорий. AI Dungeon генерирует истории; Adventure Venture управляет игровым движком.",
  about_faq_q2: "NPC с ИИ действительно помнят события между сессиями?",
  about_faq_a2: "Да — именно эта функция больше всего удивила бета-игроков. Каждый NPC хранит воспоминания о ваших взаимодействиях в постоянной базе данных. Они помнят нарушенное обещание, оказанную услугу, случайно заключённый союз. Вернитесь через три недели — трактирщик всё ещё знает, что вы не заплатили по счёту. Большинство ИИ-RPG платформ сбрасываются между сессиями; Adventure Venture — нет.",
  about_faq_q3: "Что такое BYOK-ценообразование в ИИ-RPG?",
  about_faq_a3: "BYOK расшифровывается как Bring Your Own Key («Принеси свой ключ»). Вместо того чтобы Adventure Venture покупала вычислительные мощности ИИ с наценкой, вы подключаете собственный API-ключ от OpenAI, Google Gemini или Anthropic Claude напрямую. Вы платите своему ИИ-провайдеру по стандартным тарифам — подписка на Adventure Venture не нужна для BYOK-пользователей. Для активных игроков это часто значительно дешевле любой платформенной подписки.",
  about_faq_q4: "Можно ли играть в Adventure Venture с друзьями?",
  about_faq_a4: "Да. Adventure Venture поддерживает мультиплеер в реальном времени — пригласите друзей в тот же мир и приключайтесь вместе с общим ИИ-мастером, который отдельно отслеживает историю, инвентарь и репутацию каждого игрока. Это одна из немногих ИИ-RPG платформ, способных по-настоящему заменить живого Мастера Подземелий для целой группы.",
  about_faq_q5: "Как присоединиться к закрытому бета-тестированию?",
  about_faq_a5: "Создайте бесплатный аккаунт и вступите в список ожидания — мы рассматриваем заявки и отправляем приглашения по мере открытия мест. Ранние участники навсегда получат статус Основателей в сообществе игроков.",
  about_faq_q6: "Adventure Venture бесплатна?",
  about_faq_a6: "Adventure Venture предлагает бесплатный уровень для изучения платформы и коротких кампаний. Полный режим BYOK — когда вы предоставляете собственные API-ключи — часто обходится дешевле подписки на платформу для активных игроков, поскольку вы платите своему ИИ-провайдеру по стандартным тарифам без наценки.",

  explore_byok_title: "Свой API-ключ",
  explore_byok_desc: "Используйте свои ключи для текста, голоса и поиска — играйте без ограничений за фиксированную месячную плату.",
  explore_byok_cta: "Подробнее",
  explore_byok_feature_1: "Безлимитная генерация текста с ключом Gemini",
  explore_byok_feature_2: "Собственные голоса ElevenLabs и Inworld",
  explore_byok_feature_3: "Выбор модели ИИ для каждого агента",
  explore_byok_feature_4: "SERP-поиск с вашим ключом",
  pricing_byok_title: "Свой API-ключ",
  pricing_byok_desc: "Для продвинутых пользователей, которые хотят полный контроль.",
  pricing_byok_price: "$20",
  pricing_byok_per_month: "/мес",
  pricing_byok_feature_1: "Безлимитная генерация текста (ваш ключ Gemini)",
  pricing_byok_feature_2: "Безлимитный TTS (ваш ElevenLabs / Inworld)",
  pricing_byok_feature_3: "Безлимитный SERP-поиск (ваш ключ)",
  pricing_byok_feature_4: "Выбор модели для каждого агента",
  pricing_byok_feature_5: "Wiki и Fandom используют кредиты платформы",
  pricing_byok_note: "Вы предоставляете свои API-ключи. Только Wiki и Fandom используют кредиты.",
  pricing_byok_cta: "Начать",

  // ── Explore page ──
  explore_hero_title_1: "Создай",
  explore_hero_title_2: "любую игру",
  explore_hero_desc: "Текстовый игровой движок на базе ИИ. Создавайте RPG, стратегии, симуляторы, фанфики — или что-то совершенно новое. Стройте мир, ИИ управляет им.",
  explore_cta_start: "Встать в очередь",
  explore_cta_dashboard: "В панель управления",
  explore_cta_browse: "Обзор миров",
  explore_how_compare: "Как мы выглядим на фоне конкурентов",
  explore_how_compare_desc: "Большинство ИИ-инструментов для текстовых приключений предлагают простое повествование. Мы создали полноценный игровой движок.",
  explore_feature: "Функция",
  explore_show_more: "Ещё функции",
  explore_show_less: "Показать меньше",
  explore_comparison_note: "Сравнение основано на публично доступных функциях по состоянию на март 2026. «Частично» означает ограниченную или базовую реализацию.",
  explore_what_create: "Что вы создадите?",
  explore_what_create_desc: "От криминальных империй до фанфиков — вот вкус того, что возможно.",
  explore_mechanics_title: "Игровые механики",
  explore_mechanics_desc: "Комбинируйте эти системы для создания любого жанра. Каждая механика — строительный блок — соединяйте их для уникального геймплея.",
  explore_alpha_title: "Закрытое бета-тестирование — Вы среди первых.",
  explore_alpha_desc: "Вы получаете доступ к Adventure Venture в процессе разработки — функции выходят еженедельно, и участники основателей напрямую влияют на то, что создаётся. Ваш отзыв о том, что работает, чего не хватает, и что сломано, имеет реальное значение. Ранние участники бета-версии навсегда остаются в статусе Основателей.",
  explore_ready_title: "Готовы создать свой мир?",
  explore_ready_desc: "Код не нужен. Опишите свой мир, настройте механики, и позвольте ИИ оживить его. Играйте в одиночку или пригласите друзей.",
  explore_get_started: "Встать в очередь",

  // ── Roadmap page ──
  roadmap_badge: "Дорожная карта",
  roadmap_title: "Куда мы движемся",
  roadmap_desc: "От магии создания миров до мультиплеерного хаоса — всё, что мы выпустили, что готовится и что на горизонте.",
  roadmap_features: "функций",
  roadmap_cta_title: "Есть предложение?",
  roadmap_cta_desc: "Мы создаём то, что хочет сообщество. Делитесь идеями на форумах и голосуйте за следующие функции.",
  roadmap_cta_forums: "Посетить форумы",
  roadmap_cta_explore: "Обзор миров",
  roadmap_status_live: "Работает",
  roadmap_status_beta: "Бета",
  roadmap_status_alpha: "Альфа",
  roadmap_status_planned: "Планируется",
  roadmap_status_exploring: "Исследуется",
  roadmap_item_world_builder: "ИИ-агент создания миров",
  roadmap_item_world_builder_desc: "Разговорный ИИ-помощник, создающий целые миры — NPC, локации, фракции, сюжетные зацепки и механики — из описаний на естественном языке.",
  roadmap_item_mechanics: "30+ игровых механик",
  roadmap_item_mechanics_desc: "Бой, инвентарь, экономика, репутация, мораль, выживание, магия, контроль территории, организации и многое другое.",
  roadmap_item_narrator: "ИИ-рассказчик и движок историй",
  roadmap_item_narrator_desc: "Мульти-агентный оркестр с директором сложности, движком последствий и системой темпа для динамичных историй.",
  roadmap_item_image_gen: "Генерация изображений ИИ",
  roadmap_item_image_gen_desc: "Создание портретов, сцен и локаций с поиском референсов, стилевыми ссылками и кодексом.",
  roadmap_item_tts: "Озвучка текста",
  roadmap_item_tts_desc: "Множество голосовых актёров с настраиваемыми голосами для каждого NPC. Иммерсивное аудио.",
  roadmap_item_document: "Загрузка и анализ документов",
  roadmap_item_document_desc: "Загрузка .txt, .md, .json для создания миров. Извлечение кодекса, RAG-индексация и генерация сущностей.",
  roadmap_item_journal: "Журнал и экспорт историй",
  roadmap_item_journal_desc: "Создание дневниковых записей и прозы из приключения. Экспорт в Markdown.",
  roadmap_item_npc_agents: "Мульти-агентные NPC",
  roadmap_item_npc_agents_desc: "У каждого NPC своя личность, память, знания и эмоции. Они помнят ваши поступки и реагируют соответственно.",
  roadmap_item_quest_journal: "Журнал квестов и отслеживание",
  roadmap_item_quest_journal_desc: "Динамическое обнаружение, принятие, прогресс и завершение квестов. Главные, побочные и скрытые.",
  roadmap_item_fan_fiction: "Онлайн-исследование",
  roadmap_item_fan_fiction_desc: "Импорт справочных материалов из сети — ИИ впитывает лор, факты и правила мира из Google, Википедии и Fandom для обогащения историй.",
  roadmap_item_custom_rules: "Движок пользовательских правил",
  roadmap_item_custom_rules_desc: "Определяйте правила игры простым текстом. ИИ применяет их вместе со встроенными механиками.",
  roadmap_item_forums: "Форумы и личные сообщения",
  roadmap_item_forums_desc: "Делитесь мирами, обсуждайте стратегии и общайтесь. Система друзей с прямыми сообщениями.",
  roadmap_item_research: "Модуль исследований",
  roadmap_item_research_desc: "Встроенный поиск Google, Википедии и Fandom. Автоимпорт лора, референсов и канонических фактов.",
  roadmap_item_multiplayer: "Кооперативный мультиплеер",
  roadmap_item_multiplayer_desc: "Играйте с друзьями. Пошаговые ходы, инициатива или свободный режим — с управлением группой и общими квестами.",
  roadmap_item_world_map: "Интерактивная карта мира",
  roadmap_item_world_map_desc: "Визуальный редактор карт с узлами, подкартами, слоями и привязкой локаций. Навигация в игре.",
  roadmap_item_map_library: "Библиотека изображений карт",
  roadmap_item_map_library_desc: "Загрузка изображений карт, создание SVG и мульти-вариантных видов с разными стилями.",
  roadmap_item_byoai: "Свой ИИ (18+)",
  roadmap_item_byoai_desc: "Подключите свой ключ Gemini API для нецензурированного ИИ. Полная творческая свобода.",
  roadmap_item_music: "Система музыки и атмосферы",
  roadmap_item_music_desc: "Загрузка треков, привязка к сценам. Фоновая музыка, адаптирующаяся к настроению.",
  roadmap_item_mobile: "Мобильное приложение",
  roadmap_item_mobile_desc: "Нативный мобильный опыт. Оптимизированный интерфейс, push-уведомления и оффлайн-чтение.",
  roadmap_item_marketplace: "Маркетплейс миров",
  roadmap_item_marketplace_desc: "Продавайте миры и сценарии. Устанавливайте цены или предлагайте бесплатные версии.",
  roadmap_item_voice_chat: "Голосовой чат с ИИ-мастером",
  roadmap_item_voice_chat_desc: "Голосовые разговоры в реальном времени с рассказчиком. Говорите действия и слушайте историю.",
  roadmap_item_campaign: "Режим кампании",
  roadmap_item_campaign_desc: "Многосессионные кампании с сохранением, главами и ветвящимися сюжетными арками.",
  roadmap_item_pdf_export: "Экспорт PDF и электронных книг",
  roadmap_item_pdf_export_desc: "Экспорт приключения как форматированной PDF-книги — с главами, артом персонажей и картами.",
  roadmap_item_streaming: "Интеграция со стримингом",
  roadmap_item_streaming_desc: "OBS-оверлеи, чат Twitch и голосование аудитории для совместных стримов.",
  roadmap_item_video: "ИИ-видеоролики",
  roadmap_item_video_desc: "Короткие видеоклипы для ключевых моментов — появление боссов, драматические смерти, эпические победы.",
  roadmap_item_vr: "Интеграция VR",
  roadmap_item_vr_desc: "Войдите в свой мир. VR-рендеринг, пространственное аудио и иммерсивное исследование карт.",
  roadmap_item_procgen: "Процедурная генерация миров",
  roadmap_item_procgen_desc: "Создание мира одним кликом — география, политика, история и сотни взаимосвязанных NPC.",

  // ── Support Us / Pricing page ──
  support_badge: "Поддержите проект",
  support_title: "Подпитайте приключения",
  support_desc: "Кредиты питают всё — создание миров, ИИ-озвучку, генерацию изображений и голос. Каждый набор также даёт XP и эксклюзивный титул.",
  support_best_value: "⭐ ЛУЧШАЯ ЦЕНА",
  support_get_pack: "Получить",
  support_what_buy: "Что покупают за кредиты?",
  support_ai_narration: "ИИ-озвучка",
  support_ai_narration_desc: "Каждое сообщение стоит ~0.01–0.04 кредитов",
  support_world_building: "Создание миров",
  support_world_building_desc: "Добавление сущностей, механик, сюжетных точек",
  support_image_voice: "Изображения и голос",
  support_image_voice_desc: "ИИ-арт и синтез речи",
  support_xp_title: "XP и титулы",
  support_xp_desc: "Каждый стартовый набор даёт бонусный XP и эксклюзивный титул, отображаемый в профиле и сообществе. Больше XP — доступ к премиум-мирам.",
  support_title_label: "Титул",
  support_lifetime_badge: "Кредиты действуют бессрочно — без срока действия, без подписки",
  support_free: "Бесплатно",
  support_pack_trial: "Пробный набор",
  support_pack_trial_desc: "Попробуйте — достаточно для создания первого мира и короткого приключения",
  support_pack_starter: "Стартовый набор",
  support_pack_starter_desc: "Создайте первый мир и проведите несколько приключений с ИИ-повествованием",
  support_pack_adventurer: "Набор искателя",
  support_pack_adventurer_desc: "Создавайте богатые миры, проводите множество приключений и генерируйте десятки изображений",
  support_pack_hero: "Набор героя",
  support_pack_hero_desc: "Раскройте весь потенциал — огромные миры, безлимитное ИИ-повествование, озвучка и премиум-арт",
  support_pack_legend: "Набор легенды",
  support_pack_legend_desc: "Для настоящих энтузиастов — постройте империю миров, делитесь с друзьями и станьте легендой платформы",

  // ── Contact page ──
  contact_badge: "Связаться",
  contact_title: "Свяжитесь с нами",
  contact_desc: "Есть вопрос, предложение или просто хотите поздороваться? Мы будем рады услышать вас.",
  contact_send_message: "Отправить сообщение",
  contact_respond_time: "Обычно отвечаем в течение 24 часов.",
  contact_name: "Имя",
  contact_name_placeholder: "Ваше имя",
  contact_email: "Эл. почта",
  contact_email_placeholder: "your@email.com",
  contact_subject: "Тема",
  contact_subject_placeholder: "О чём хотите написать?",
  contact_message: "Сообщение",
  contact_message_placeholder: "Расскажите, что у вас на уме...",
  contact_send: "Отправить сообщение",
  contact_github: "GitHub",
  contact_github_desc: "Сообщить об ошибках и предложить функции",
  contact_community: "Сообщество",
  contact_community_desc: "Присоединяйтесь к обсуждению на форумах",
  contact_support_cta: "Хотите поддержать проект?",
  contact_support_cta_desc: "Ознакомьтесь с нашими стартовыми наборами для получения кредитов и эксклюзивных титулов!",
  contact_fill_required: "Пожалуйста, заполните все обязательные поля",
  contact_sent_success: "Сообщение отправлено! Мы свяжемся с вами в ближайшее время.",
  contact_sent_error: "Не удалось отправить сообщение. Попробуйте ещё раз.",

  // ── Community page ──
  community_forums: "Форумы",
  community_loading: "Загрузка форумов...",
  forum_title: "Форумы сообщества",
  forum_col_forum: "Форум",
  forum_col_topics: "Темы",
  forum_col_posts: "Сообщения",
  forum_col_last_post: "Последнее",
  forum_no_categories: "Пока нет разделов форума.",
  forum_no_posts_yet: "Пока нет сообщений",
  forum_stats_title: "Статистика форума",
  forum_total_topics: "Всего тем",
  forum_total_posts: "Всего сообщений",
  forum_total_members: "Всего участников",
  forum_newest_member: "Новый участник",
  forum_by: "от",
  forum_start_new_topic: "Новая тема",
  forum_create_topic_title: "Создать тему",
  forum_topic_title_placeholder: "Название темы...",
  forum_first_post_placeholder: "Напишите первое сообщение...",
  forum_post_anonymously: "Опубликовать анонимно",
  forum_create_topic: "Создать тему",
  forum_no_topics: "Пока нет тем.",
  forum_no_topics_desc: "Будьте первым — начните обсуждение!",
  forum_col_topic: "Тема",
  forum_col_replies: "Ответы",
  forum_col_views: "Просмотры",
  forum_pinned_topics: "Закреплённые темы",
  forum_topics: "Темы",
  forum_posts_count: "сообщений",
  forum_views_count: "просмотров",
  forum_locked: "Закрыта",
  forum_topic_not_found: "Тема не найдена.",
  forum_edited: "(изменено)",
  forum_unpin: "Открепить тему",
  forum_pin: "Закрепить тему",
  forum_unlock: "Разблокировать тему",
  forum_lock: "Заблокировать тему",
  forum_save: "Сохранить",
  forum_cancel: "Отмена",
  forum_quote: "Цитата",
  forum_reply_placeholder: "Написать ответ...",
  forum_post_reply: "Отправить",
  forum_topic_locked: "Тема закрыта и не принимает новых ответов.",
  forum_joined: "Вступил",
  forum_member_veteran: "Ветеран",
  forum_member_regular: "Завсегдатай",
  forum_member_active: "Активный",
  forum_member_member: "Участник",
  forum_member_newcomer: "Новичок",
  forum_time_just_now: "только что",
  forum_time_minutes_ago: "мин назад",
  forum_time_hours_ago: "ч назад",
  forum_time_days_ago: "д назад",
  forum_post_updated: "Пост обновлён!",
  forum_update_failed: "Ошибка обновления: {error}",
  forum_action_failed: "Ошибка: {error}",
  forum_react_failed: "Не удалось поставить реакцию",

  // ── Not Found page ──
  notfound_title: "404",
  notfound_desc: "Ой! Страница не найдена",
  notfound_back: "Вернуться на главную",

  // ── Gameplay UI ──
  play_anonymous: "Аноним",
  play_you_suffix: "(вы)",
  play_turn_label: "Ход",
  play_invite_copied: "Ссылка-приглашение скопирована!",
  play_present: "Присутствуют",
  play_scene_tags: "Теги сцены",
  play_day: "День",
  play_time: "Время",
  play_mode: "Режим",
  play_combat: "Бой",
  play_phase: "Фаза",
  play_initiative_order: "Порядок инициативы",
  play_player_character: "Персонаж игрока",
  play_hp: "ОЗ",
  play_level: "Уровень",
  play_gold: "Золото",
  play_no_character: "Данных о персонаже пока нет",
  play_character: "Персонаж",
  play_world: "Мир",
  play_journal: "Журнал",
  play_director: "Режиссёр",
  play_party_chat: "Чат группы",
  play_no_messages: "Пока нет сообщений. Поприветствуйте группу!",
  play_message_party: "Написать группе...",
  play_send_failed: "Не удалось отправить сообщение",
  play_portrait: "Портрет",
  play_conditions: "Состояния",
  play_inventory_empty: "Инвентарь пуст",
  play_weight: "Вес",
  play_encumbered: "Перегружен",
  play_heavy_load: "Тяжёлый груз",
  play_overburdened: "Сверхнагрузка",
  play_base: "Базовый",
  play_active_bonuses: "Активные бонусы",
  play_equipped: "Экипировано",
  play_available: "доступно",
  
  play_complete: "завершено",
  play_failed: "провалено",
  play_create_quest: "Создать квест",
  play_quest_goal: "Опишите цель квеста...",
  play_go: "Вперёд",
  play_no_quests: "Нет квестов: {tab}",
  play_accept: "Принять",
  play_rewards: "Награды",
  play_personal: "личный",
  play_diary: "Дневник",
  play_story: "История",
  play_no_adventure: "Приключение не загружено",
  play_no_entries: "Записей пока нет",
  play_write_hint: "Напишите запись в дневнике или создайте историю",
  play_story_caught_up: "История актуальна — играйте дальше или перепишите.",
  play_story_style_placeholder: "напр. Используй короткие ёмкие предложения. Избегай пышных описаний. Больше диалогов.",
  play_action_details: "Детали...",
  play_critical: "КРИТИЧЕСКИЙ!",
  play_fumble: "ПРОВАЛ!",
  play_lore_codex: "Кодекс знаний",
  play_search_lore: "Искать знания…",
  play_edit_world: "Редактировать мир",
  play_edit_template: "Редактировать шаблон",
  play_edit_game: "Редактировать игру",
  play_editing_game_banner: "Редактирование экземпляра игры",
  play_editing_game_subtitle: "Изменения затронут только эту игру, а не шаблон",
  play_mode_editor: "Редактор",
  play_mode_play: "Играть",
  play_mode_switch_aria: "Переключить между редактором и игрой",
  play_multiplayer: "Мультиплеер",
  play_your_turn_badge: "🎯 Ваш ход",
  play_other_turn: "⏳ Ход {name}",
  play_waiting_other: "Ожидание хода другого игрока...",
  play_hidden_messages: "{count} скрытых сообщений",
  play_reclassify_fail: "Не удалось переклассифицировать",
  play_reclassify_success: "Переклассифицировано как {label}",
  play_continue_story: "Продолжить историю",
  play_rewrite_all: "Переписать всё",
  play_chapter: "Глава",
  play_entry: "Запись",
  play_new_story: "Новая история",
  play_journal_entry: "Запись в журнале",
  play_read_full: "Читать полностью",
  play_no_data: "Нет данных: {label}",

  // ── Multiplayer Communication ──
  mp_tab_chat: "Чат",
  mp_tab_board: "Доска",
  mp_tab_interactions: "Взаимодействия",
  mp_board_title: "Доска приключения",
  mp_no_threads: "Тем пока нет — создайте первую!",
  mp_new_thread: "Новая тема",
  mp_thread_title: "Заголовок темы…",
  mp_write_post: "Напишите пост…",
  mp_create_thread: "Создать тему",
  mp_reply_placeholder: "Написать ответ…",
  mp_interactions_title: "Взаимодействия игроков",
  mp_no_interactions: "Взаимодействий пока нет",
  mp_new_interaction: "Новое взаимодействие",
  mp_trade: "Обмен",
  mp_gift: "Подарок",
  mp_challenge: "Вызов",
  mp_alliance: "Запрос союза",
  mp_select_player: "Выберите игрока…",
  mp_offered_items: "Предметы для обмена (через запятую)",
  mp_requested_items: "Запрашиваемые предметы (через запятую)",
  mp_offered_gold: "Золото предложено",
  mp_requested_gold: "Золото запрошено",
  mp_interaction_message: "Добавить сообщение…",
  mp_offering: "Предлагает",
  mp_requesting: "Запрашивает",
  mp_decline: "Отклонить",
  mp_not_enough_gold: "Недостаточно золота",
  mp_leave_adventure: "Покинуть приключение",
  mp_leave_failed: "Не удалось покинуть приключение",
  mp_left_adventure: "Вы покинули приключение",
  mp_kick_failed: "Не удалось исключить игрока",
  mp_player_kicked: "Игрок исключён",
  mp_kick_confirm: "Вы уверены, что хотите исключить этого игрока?",
  mp_kick: "Исключить",
  mp_spectator: "Зритель",
  mp_you_badge: "вы",
  mp_host_badge: "хост",
  mp_anonymous_player: "Аноним",
  mp_your_char_name: "Имя вашего персонажа",
  mp_waiting_for_host: "Ожидаем, пока ведущий запустит приключение...",
  mp_invite_code_copied: "Код приглашения скопирован!",
  mp_invite_link_copied: "Ссылка приглашения скопирована!",
  mp_share_invite_code: "Поделитесь кодом приглашения:",
  mp_share_invite_link: "Поделитесь этой ссылкой для приглашения игроков:",
  mp_turn_free_form: "Свободная форма",
  mp_turn_concurrent: "Одновременно",
  mp_turn_initiative: "Порядок инициативы",
  mp_turn_round_robin: "По очереди",

  // ── Builder: General Panel (About) ──
  wb_gen_about: "О мире",
  wb_gen_about_desc: "Идентичность, внешний вид и информация",
  wb_gen_featured_image: "Главное изображение",
  wb_gen_change_banner: "Изменить баннер",
  wb_gen_generate_banner: "Нажмите для генерации баннера",
  wb_gen_icon: "Иконка",
  wb_gen_world_name: "Название мира",
  wb_gen_world_name_placeholder: "Мой мир",
  wb_gen_description: "Описание",
  wb_gen_description_placeholder: "Краткий обзор вашего мира — что делает его уникальным?",
  wb_gen_promo_title: "Генератор промо-текста",
  wb_gen_promo_desc: "Автоматическая генерация промо-текста из сценариев, персонажей и квестов.",
  wb_gen_promo_generate: "Сгенерировать",
  wb_gen_promo_regenerate: "Сгенерировать заново",
  wb_gen_promo_seed: "Начальный текст",
  wb_gen_promo_seed_placeholder: "Укажите отправную точку или ключевые моменты...",
  wb_gen_promo_style: "Стиль",
  wb_gen_promo_length: "Длина",
  wb_gen_promo_style_professional: "Профессиональный",
  wb_gen_promo_style_epic: "Эпический",
  wb_gen_promo_style_mysterious: "Загадочный",
  wb_gen_promo_style_casual: "Повседневный",
  wb_gen_promo_length_short: "Короткий (1-2 строки)",
  wb_gen_promo_length_medium: "Средний (1-2 абзаца)",
  wb_gen_promo_length_long: "Длинный (3-6 абзацев)",
  wb_gen_promo_analyzing: "Анализ сценариев, персонажей и квестов…",
  wb_gen_promo_copy: "Копировать",
  wb_gen_promo_use_desc: "Использовать как описание",
  wb_gen_genre_themes: "Жанр и темы",
  wb_gen_auto_detect: "Авто-определение",
  wb_gen_genre: "Жанр",
  wb_gen_genre_placeholder: "Напр. тёмное фэнтези, научная фантастика, стимпанк",
  wb_gen_themes: "Темы",
  wb_gen_themes_placeholder: "Напр. искупление, борьба за власть, выживание",
  wb_gen_content_language: "Язык контента",
  wb_gen_content_language_desc: "Весь AI-контент (сущности, сюжеты, кодекс, повествование) будет на этом языке.",
  wb_gen_tags: "Теги",
  wb_gen_add_tag: "Добавить тег...",
  wb_gen_add: "Добавить",
  wb_gen_translations: "Переводы",
  wb_gen_translate_now: "Перевести сейчас",
  wb_gen_auto_translate: "Авто-перевод при сохранении",
  wb_gen_auto_translate_desc: "Автоматически переводить название, описание и теги при сохранении",
  wb_gen_primary_language: "Основной язык",
  wb_gen_info: "Информация",
  wb_gen_world_id: "ID мира",
  wb_gen_created_by: "Создано",
  wb_gen_created: "Создан",
  wb_gen_saving: "Сохранение…",
  wb_gen_save_changes: "Сохранить изменения",
  wb_gen_saved: "Сохранено",
  wb_gen_name_label: "Имя",

  // ── Builder: General Panel (Generation) ──
  wb_gen_world_generation: "Генерация мира",
  wb_gen_world_generation_desc: "Управляет интенсивностью авто-генерации контента",
  wb_gen_level_conservative: "Консервативный",
  wb_gen_level_balanced: "Сбалансированный",
  wb_gen_level_aggressive: "Агрессивный",
  wb_gen_level_active: "Активен",
  wb_gen_auditor: "Аудитор непрерывности",
  wb_gen_auditor_desc: "AI-агент, периодически проверяющий историю на несоответствия, дыры в сюжете и нарушения — с авто-исправлением.",
  wb_gen_enable_auditor: "Включить аудитор",
  wb_gen_auditor_runs: "Запускается каждые N ходов для проверки повествования",
  wb_gen_audit_interval: "Интервал аудита (ходов)",
  wb_gen_audit_frequent: "5 (часто)",
  wb_gen_audit_rare: "30 (редко)",

  // ── Builder: General Panel (Privacy) ──
  wb_gen_privacy: "Приватность и доступ",
  wb_gen_privacy_desc: "Управляйте, кто может видеть ваш мир",
  wb_gen_under_dev: "В разработке",
  wb_gen_under_dev_desc: "Игроки увидят уведомление о незавершённости.",
  wb_gen_public_world: "Публичный мир",
  wb_gen_public_world_desc: "Любой может найти и просмотреть этот мир",
  wb_gen_invite_only: "Только по приглашению",
  wb_gen_invite_only_desc: "Игрокам нужно приглашение для входа",
  wb_gen_allow_cloning: "Разрешить клонирование",
  wb_gen_allow_cloning_desc: "Другие могут скопировать этот мир как шаблон",
  wb_gen_pricing: "Цены и кредиты",
  wb_gen_pricing_desc: "Установите стоимость для игроков. 0 = бесплатно.",
  wb_gen_ticket_cost: "Стоимость билета (за сессию)",
  wb_gen_ticket_cost_desc: "Кредиты за начало нового приключения",
  wb_gen_clone_price: "Цена клонирования",
  wb_gen_clone_price_desc: "Кредиты за копирование мира",
  wb_gen_min_xp: "Минимальный XP",
  wb_gen_min_xp_desc: "Игрокам нужно столько XP для доступа (0 = без ограничений)",
  wb_gen_free_for_players: "Бесплатно для игроков",
  wb_gen_free_for_players_desc: "Вы берёте на себя все расходы. Игроки играют бесплатно.",

  // ── Builder: General Panel (Actions) ──
  wb_gen_actions: "Действия",
  wb_gen_actions_desc: "Клонировать или удалить мир",
  wb_gen_clone_world: "Клонировать мир",
  wb_gen_delete_world: "Удалить мир",
  wb_gen_clone_dialog_title: "Клонировать мир",
  wb_gen_clone_dialog_desc: "Создаёт полную копию со всеми сущностями, сюжетами, агентами, сценариями и музыкой.",
  wb_gen_new_world_name: "Название нового мира",
  wb_gen_clone_btn: "Клонировать",
  wb_gen_delete_dialog_title: "Удалить мир",
  wb_gen_delete_dialog_desc: "Это навсегда удалит \"{name}\" и все его сущности, сюжеты, агентов, сценарии и медиа.",
  wb_gen_delete_cannot_undo: "Это действие нельзя отменить.",
  wb_gen_delete_permanently: "Удалить навсегда",

  // ── Builder: Entities Panel ──
  wb_ent_no_entities: "Сущностей пока нет",
  wb_ent_no_entities_desc: "Опишите мир в чате, и AI создаст сущности автоматически.",
  wb_ent_search: "Поиск сущностей...",
  wb_ent_no_match: "Нет сущностей для этого вида.",

  // ── Builder: Plot Panel ──
  wb_plot_quests: "Квесты",
  wb_plot_story: "Сюжет",
  wb_plot_conditions: "Условия",
  wb_plot_quests_desc: "Основные и побочные квесты с целями и привязкой к сценариям.",
  wb_plot_story_desc: "Ключевые моменты, события, зацепки, конфликты и лор.",
  wb_plot_conditions_desc: "Условия победы, поражения и завершения.",
  wb_plot_objectives: "Цели",
  wb_plot_add_objective: "Добавить цель...",
  wb_plot_relevance_critical: "Критичный",
  wb_plot_relevance_high: "Высокий",
  wb_plot_relevance_medium: "Средний",
  wb_plot_relevance_low: "Низкий",
  wb_plot_relevance_background: "Фоновый",
  wb_plot_new_entry: "Новая запись",
  wb_plot_no_entries: "Записей пока нет.",

  // ── Builder: Scenarios Panel ──
  wb_sc_desc: "Определите стартовые сценарии — шаблоны для начала приключений.",
  wb_sc_new: "Новый сценарий",
  wb_sc_no_scenarios: "Сценариев пока нет.",
  wb_sc_no_scenarios_desc: "Создайте сценарии для структурированных стартов. Без сценариев приключения начинаются свободно.",
  wb_sc_create_first: "Создать первый сценарий",
  wb_sc_default: "По умолчанию",
  wb_sc_set_default: "Сделать по умолчанию",
  wb_sc_title: "Название",
  wb_sc_description: "Описание",
  wb_sc_opening: "Вступительное повествование",
  wb_sc_starting_location: "Начальная локация",
  wb_sc_difficulty: "Сложность",
  wb_sc_allow_custom: "Разрешить своих персонажей",
  wb_sc_guidelines: "Правила создания персонажей",
  wb_sc_progressions: "Развитие сюжета",
  wb_sc_add_progression: "Добавить развитие",
  wb_sc_characters: "Доступные персонажи",
  wb_sc_tags: "Теги",
  wb_sc_needs_title: "Сценарию нужно название",

  // ── Builder: Players Panel ──
  wb_pc_title: "Персонажи игроков",
  wb_pc_desc: "Готовые персонажи, которых игроки могут выбрать при старте приключения.",
  wb_pc_new: "Новый персонаж",
  wb_pc_no_characters: "Персонажей пока нет.",
  wb_pc_no_characters_desc: "Создайте персонажей для выбора или позвольте игрокам создать своих.",
  wb_pc_create_first: "Создать первого персонажа",
  wb_pc_identity: "Идентичность",
  wb_pc_backstory: "Предыстория",
  wb_pc_personality: "Личность",
  wb_pc_stats: "Характеристики",
  wb_pc_inventory: "Инвентарь",

  // ── Builder: Mechanics Panel ──
  wb_mech_search: "Поиск механик...",
  wb_mech_allow_dynamic: "Динамические механики",
  wb_mech_allow_dynamic_desc: "Разрешить AI добавлять/удалять механики во время игры",
  wb_mech_active: "активно",
  wb_mech_guidance_placeholder: "Опишите, как эта механика проявляется в вашем мире — кто ею управляет, где к ней обращаются, что требуется нарративно.",

  // ── Builder: Agent Chat Dialog ──
  wb_agent_select_npc: "Выберите NPC…",
  wb_agent_describe_self: "Опишите, кто вы…",
  wb_agent_select_location: "Выберите локацию…",
  wb_agent_location_example: "Тёмная таверна…",
  wb_agent_time_example: "Поздний вечер…",
  wb_agent_context_example: "Что только что произошло, настроение…",

  // ── Builder: Agent Editor ──
  wb_agent_no_linked_entity: "Нет связанной сущности",
  wb_agent_traits_placeholder: "храбрый, хитрый, добрый...",
  wb_agent_values_placeholder: "честь, свобода, знания...",
  wb_agent_fears_placeholder: "одиночество, огонь...",
  wb_agent_goals_placeholder: "найти артефакт, защитить деревню...",
  wb_agent_speech_patterns_placeholder: "говорит загадками, использует метафоры...",
  wb_agent_verbal_tics_placeholder: "'действительно', прочищает горло, вздыхает...",
  wb_agent_use_world_default: "Использовать настройки мира",
  wb_agent_use_default_model: "Использовать модель по умолчанию",

  // ── Builder: Checklist Panel ──
  wb_checklist_task_name: "напр., Создать магическую систему",
  wb_checklist_task_desc: "Краткое описание",
  wb_checklist_task_prompt: "Сообщение, отправляемое ИИ при нажатии...",

  // ── Builder: Context Panel ──
  wb_context_desc_placeholder: "Добавьте описание мира...",

  // ── Builder: Custom Rules Editor ──
  wb_rule_title_placeholder: "напр., Языковой барьер",
  wb_rule_text_placeholder: "Опишите правило, которому должен следовать ИИ...",

  // ── Builder: Entities Panel ──
  wb_ent_search_placeholder: "Поиск сущностей...",

  // ── Builder: Entity Detail Dialog ──
  wb_ent_add_tag: "добавить_тег...",
  wb_ent_json_data: "JSON данные",
  wb_ent_refine_instructions: "напр., Сосредоточься на военной истории, добавь больше примеров диалога...",
  wb_ent_name_placeholder: "Имя сущности",
  wb_ent_tag_input: "Добавить тег...",
  wb_ent_desc_detail: "Подробно опишите сущность...",

  // ── Builder: Entity Property Helpers ──
  wb_ent_custom_field: "своё_поле",

  // ── Builder: General Panel ──
  wb_gen_promo_section_placeholder: "Рекламный текст для этого раздела… Оставьте пустым, чтобы показать сценарии.",

  // ── Builder: Group Chat Dialog ──
  wb_group_location_placeholder: "Таверна, тронный зал...",
  wb_group_time_placeholder: "Вечер, после битвы...",

  // ── Builder: Initial Threads Editor ──
  wb_thread_desc_placeholder: "О чём этот нарративный поток? Напр., 'Торговый обоз пропал на северной дороге...'",
  wb_thread_hook_placeholder: "Как это может впервые появиться в истории...",

  // ── Builder: Player Characters Panel ──
  wb_pc_backstory_placeholder: "Введите предысторию как текст или вставьте структурированный JSON...",
  wb_pc_name_placeholder: "Алдрик Храбрый",
  wb_pc_class_placeholder: "Воин, Маг, Плут...",
  wb_pc_desc_placeholder: "Странствующий рыцарь, ищущий искупления...",
  wb_pc_playstyle_placeholder: "Агрессивный, дипломатичный, скрытный...",

  // ── Builder: Relationship Editor ──
  wb_rel_search_entities: "Поиск сущностей...",
  wb_rel_custom_name: "Или введите своё имя...",
  wb_rel_type_search: "Введите или найдите...",
  wb_rel_custom_type: "Свой тип...",
  wb_rel_desc: "Описание (необязательно)",
  wb_rel_notes: "Заметки (необязательно)",

  // ── Builder: Scenarios Panel ──
  wb_sc_title_placeholder: "Тёмный лес пробуждается...",
  wb_sc_desc_placeholder: "Краткий обзор, который игроки увидят при выборе...",
  wb_sc_opening_placeholder: "Текст, который игроки читают в начале приключения...",
  wb_sc_location_placeholder: "Туманная таверна",
  wb_sc_guidelines_placeholder: "напр., Персонажи должны быть людьми, без магов...",
  wb_sc_path_name: "Название пути",
  wb_sc_path_desc: "Описание",
  wb_sc_item_name: "Название предмета",
  wb_sc_item_qty: "Кол-во",
  wb_sc_item_category: "Категория",
  wb_sc_item_rarity: "Редкость",
  wb_sc_tags_placeholder: "мистика, боевые действия, исследование...",

  // ── Builder: Share World Dialog ──
  wb_share_email_placeholder: "Email пользователя...",

  // ── Builder: Source References Panel ──
  wb_src_title_placeholder: "Название (напр., Фандом-вики Star Wars)",
  wb_src_url_placeholder: "URL (необязательно)",
  wb_src_desc_placeholder: "Краткое описание",

  // ── Builder: Style References Panel ──
  wb_style_label_placeholder: "напр., Стиль локации",

  // ── Builder: Template Selector ──
  wb_template_search: "Поиск шаблонов...",

  // ── Builder: Voice Controls Panel ──
  wb_voice_select_placeholder: "Выберите голос...",
  wb_voice_id_placeholder_venice: "напр., af_sky",
  wb_voice_id_placeholder_elevenlabs: "напр., JBFqnCBsd6RMkjVDRZzb",
  wb_voice_sample_placeholder: "Короткий текст для предпрослушивания голоса",
  wb_voice_describe_placeholder: "Опишите голос... глубокий мужской, мягкий женский, загадочный",

  // ── Builder: Art Direction Tab ──
  wb_art_direction_placeholder: "напр., тёмное мрачное освещение, кинематографичная композиция...",
  wb_art_brief_manual_placeholder: "Напишите визуальное описание вручную...",

  // ── Index / World Stats ──
  idx_characters: "персонаж",
  idx_scenarios: "сценарий",
  idx_entities: "сущность",
  idx_all_worlds: "Все миры",
  idx_all_worlds_admin: "Все миры (Админ)",

  // ── Header Credits ──
  hdr_credits: "кредиты",
  hdr_credit_wallet: "Кошелёк кредитов",
  hdr_usage_dashboard: "Панель использования",
  hdr_pricing_rates: "Цены и тарифы",
  hdr_earn_credits: "Заработать кредиты",
  hdr_ai_disabled: "Все функции AI отключены",
  hdr_building_disabled: "Создание миров отключено (нужно 50+)",

  // ── Reset Password page ──
  reset_title_done: "Готово!",
  reset_title_new: "Новый пароль",
  reset_desc_done: "Ваш пароль обновлён. Перенаправление…",
  reset_desc_new: "Выберите новый пароль для вашего аккаунта",
  reset_redirecting: "Перенаправление в панель управления…",
  reset_link_expired: "Эта ссылка могла устареть или недействительна. Запросите новый сброс пароля.",
  reset_back_sign_in: "Вернуться ко входу",
  reset_new_password: "Новый пароль",
  reset_confirm_password: "Подтвердите пароль",
  reset_placeholder: "Минимум 6 символов",
  reset_re_enter: "Повторите пароль",
  reset_updating: "Обновление…",
  reset_update_button: "Обновить пароль",
  reset_password_min: "Пароль должен содержать не менее 6 символов.",
  reset_passwords_mismatch: "Пароли не совпадают.",
  reset_success: "Пароль успешно обновлён!",
  auth_remember_me: "Запомнить меня",
  auth_err_invalid_creds: "Неверный email или пароль. Пожалуйста, попробуйте ещё раз.",
  auth_err_email_not_confirmed: "Пожалуйста, подтвердите email перед входом. Проверьте почту.",
  auth_err_user_exists: "Аккаунт с этим email уже существует. Попробуйте войти.",
  auth_err_password_too_short: "Пароль должен содержать не менее 6 символов.",
  auth_err_rate_limit: "Слишком много попыток. Подождите немного и попробуйте снова.",
  auth_err_signup_disabled: "Регистрация временно отключена.",
  auth_err_generic: "Произошла ошибка. Пожалуйста, попробуйте снова.",
  common_generating: "Генерация...",
  common_processing: "Обработка...",
  common_resume: "Возобновить",
  common_pause: "Пауза",
  common_generate: "Сгенерировать",
  common_saving: "Сохранение...",
  wb_voice_save: "Сохранить настройки голоса",
  wb_agent_auto_generate: "Авто-генерация",
  wb_doc_generate_codex: "Сгенерировать кодекс",
  wb_doc_status_vector: "Вектор",
  wb_doc_status_text: "Текст",
  wb_doc_status_error: "Ошибка",
  wb_doc_indexed: "Проиндексировано для поиска",
  wb_doc_timeout: "Загрузка могла истечь по времени",
  wb_doc_still_processing: "Ещё обрабатывается...",
  wb_doc_error_processing: "Ошибка при обработке",
  wb_map_rename: "Переименовать",
  wb_map_upload_image: "Загрузить изображение карты",
  wb_map_upload_overlay: "Загрузить слой-наложение",
  wb_map_generate_ai: "Сгенерировать карту с ИИ",
  play_tts_disabled: "Преобразование текста в речь ({provider}) в данный момент отключено для вашего аккаунта.",
  play_setup_char_name: "Имя персонажа...",
  play_setup_char_desc: "Краткое описание персонажа (ИИ поможет дополнить)...",
  play_setup_adventure_name: "Название приключения...",
  gm_ask_placeholder: "Спросите GM… (Shift+Enter для новой строки)",
  notes_title_placeholder: "Заголовок заметки…",
  notes_content_placeholder: "Напишите вашу заметку…",
  notes_untitled: "Без названия",
  notes_untitled_note: "Заметка без названия",
  social_search_placeholder: "Поиск по имени или эл. почте...",
  social_no_users: "Пользователи не найдены",
  social_search_failed: "Ошибка поиска",
  social_find_players: "Найти игроков",
  social_friend_requests: "Запросы дружбы",
  social_friends: "Контакты",
  social_no_friends: "Контактов пока нет. Ищите игроков выше!",
  social_sent_requests: "Отправленные запросы",
  wb_rename_failed: "Не удалось переименовать мир",
  wb_rename_tooltip: "Нажмите для переименования",
  msg_page_title: "Сообщения",
  msg_unknown_contact: "Неизвестно",
  chat_conversation_reset: "Переписка сброшена",
  chat_send_failed: "Не удалось отправить сообщение",
  chat_no_messages: "Сообщений пока нет. Скажи привет!",
  chat_type_message: "Введите сообщение...",

  // ── Accessible button labels (aria-label) ──
  aria_send_message: "Отправить сообщение",
  aria_message_options: "Настройки сообщения",
  aria_edit_message: "Редактировать сообщение",
  aria_delete_message: "Удалить сообщение",
  aria_roll_dice: "Бросить кости",
  aria_notifications: "Уведомления",
  notif_mark_all_read: "Отметить всё прочитанным",
  notif_empty: "Нет уведомлений",
  aria_pause_narration: "Приостановить озвучку",
  aria_resume_narration: "Возобновить озвучку",
  aria_stop_narration: "Остановить озвучку",
  aria_replay_narration: "Повторить озвучку",
  aria_next_track: "Следующий трек",

  // ── useMultiplayerAdventure ──
  adv_load_failed: "Ошибка загрузки приключения: {error}",
  adv_your_turn: "⚔️ Ваш ход!",
  adv_your_turn_desc: "Ход {name}",
  adv_create_failed: "Ошибка создания приключения: {error}",
  adv_invalid_invite: "Неверный код приглашения",
  adv_joined: "Вы присоединились к приключению!",
  adv_join_failed: "Ошибка при вступлении: {error}",
  adv_no_retry_msg: "Нет сообщения пользователя для повтора",
  adv_orphaned_removed: "Потерянное сообщение удалено",
  adv_msg_delete_failed: "Не удалось удалить сообщение",
  adv_msg_deleted: "Сообщение удалено",
  adv_msg_edit_failed: "Не удалось изменить сообщение",
  adv_msg_updated: "Сообщение обновлено",

  // ── useFriends ──
  friends_request_exists: "Запрос дружбы уже существует",
  friends_request_failed: "Не удалось отправить запрос дружбы",
  friends_request_sent: "Запрос дружбы отправлен!",
  friends_accept_failed: "Не удалось принять запрос",
  friends_request_accepted: "Запрос дружбы принят!",
  friends_decline_failed: "Не удалось отклонить запрос",
  friends_request_declined: "Запрос дружбы отклонён",
  friends_remove_failed: "Не удалось удалить друга",
  friends_removed: "Друг удалён",

  // ── useIndexData (Index page actions) ──
  idx_load_failed: "Не удалось загрузить данные",
  idx_file_too_large: "{name} слишком большой (макс. 2МБ)",
  idx_file_read_failed: "Не удалось прочитать {name}",
  idx_need_credits: "Нужно минимум 50 кредитов для создания мира",
  idx_create_world_failed: "Ошибка создания мира: {error}",
  idx_world_trashed: "Мир перемещён в корзину",
  idx_world_restored: "Мир восстановлен",
  idx_world_perm_deleted: "Мир удалён безвозвратно",
  idx_world_published: "Мир опубликован!",
  idx_world_unpublished: "Публикация отменена",
  idx_world_cloned: "Мир успешно клонирован!",
  idx_clone_failed: "Ошибка клонирования: {error}",
  idx_adventure_deleted: "Приключение удалено",
  idx_adventure_left: "Вы покинули приключение",
  idx_adventure_joined: "Вы присоединились к приключению!",
  idx_invalid_invite: "Неверный код приглашения",
  idx_invite_copied: "Ссылка-приглашение скопирована!",
  idx_delete_failed: "Ошибка удаления: {error}",
  idx_restore_failed: "Ошибка восстановления: {error}",
  idx_update_failed: "Ошибка обновления: {error}",
  idx_leave_failed: "Не удалось покинуть: {error}",
  idx_join_failed: "Не удалось присоединиться: {error}",
  idx_start_game_failed: "Не удалось начать игру: {error}",

  // ── DocumentUpload ──
  doc_file_too_large: "{name} слишком большой (макс. 20МБ)",
  doc_file_already_exists: "\"{name}\" уже есть в базе знаний",
  doc_file_empty: "{name} пустой",
  doc_file_duplicate_content: "\"{name}\" — дубликат уже загруженного документа",
  doc_upload_success: "{name} → {chunks} чанков ({category})",
  doc_upload_failed: "Ошибка: {error}",
  doc_no_supported_files: "Нет поддерживаемых файлов. Используйте: {types}",
  doc_deleted: "{name} удалён",
  doc_delete_failed: "Ошибка удаления: {error}",
  doc_removed_stuck: "Удалён зависший \"{name}\" — повторите загрузку",
  doc_reindexed: "{name} переиндексирован: {chunks} чанков",
  doc_reindex_failed: "Переиндексация не удалась: {error}",
  doc_codex_regenerated: "Кодекс для {name} обновлён",
  doc_codex_failed: "Обновление кодекса не удалось: {error}",
  doc_reanalyzed: "{name} повторно проанализирован: {chunks} чанков ({mode})",
  doc_reanalyze_failed: "Повторный анализ не удался: {error}",

  // ── ShareWorldDialog ──
  share_link_copied: "Ссылка скопирована!",
  share_copy_failed: "Не удалось скопировать",
  share_load_collab_failed: "Не удалось загрузить соавторов",
  share_user_not_found: "Пользователь с таким email не найден. Им нужно сначала зарегистрироваться.",
  share_cannot_add_self: "Нельзя добавить себя в соавторы.",
  share_already_collab: "Этот пользователь уже соавтор.",
  share_collab_added: "Добавлен {email} как соавтор ({role})",
  share_add_collab_failed: "Не удалось добавить: {error}",
  share_permission_updated: "Разрешение обновлено",
  share_update_failed: "Ошибка обновления: {error}",
  share_collab_removed: "Соавтор удалён",
  share_remove_failed: "Ошибка удаления: {error}",

  // ── useCreditBalance ──
  cred_img_disabled: "Генерация изображений отключена",
  cred_img_disabled_desc: "Баланс упал ниже {threshold} кредитов ({balance}). Генерация изображений отключена для экономии кредитов.",
  cred_running_low: "Кредиты заканчиваются",
  cred_running_low_desc: "Ваш баланс: {balance} кредитов. Рекомендуем экономить расход.",
  cred_voice_disabled: "Генерация голоса отключена",
  cred_voice_disabled_desc: "Баланс упал ниже {threshold} кредитов ({balance}). Функции голоса/TTS отключены.",
  cred_transfer_disabled: "Перевод кредитов отключён",
  cred_transfer_disabled_desc: "Баланс упал ниже {threshold} кредитов ({balance}). Переводы кредитов отключены.",
  cred_build_disabled: "Создание миров отключено",
  cred_build_disabled_desc: "Баланс упал ниже {threshold} кредитов ({balance}). Создание миров и функции AI-строителя отключены.",
  cred_all_disabled: "Все функции кредитов отключены",
  cred_all_disabled_desc: "Ваш баланс достиг 0. Все AI-функции отключены до пополнения кредитов.",

  // ── GeneralPanel ──
  gen_world_saved: "Данные мира сохранены",
  gen_save_failed: "Ошибка сохранения: {error}",
  gen_promo_generated: "Промо-текст создан!",
  gen_copied_clipboard: "Скопировано в буфер",
  gen_intro_applied: "Введение применено к описанию",
  gen_all_langs_translated: "Все языки уже имеют переводы",
  gen_translations_generated: "Переводы созданы!",
  gen_generation_failed: "Ошибка генерации",
  gen_translation_failed: "Ошибка перевода",

  // ── WorldMapEditor ──
  map_layer_placed: "Слой размещён на карте",
  map_polygon_created: "Полигональная зона создана",
  map_connection_added: "Соединение добавлено",
  map_placed_locations: "Размещено {count} локаций",
  map_failed_suffix: "({count} не удалось)",
  map_geocode_failed: "Не удалось геокодировать {count} локаций",
  map_all_placed: "Все локации уже размещены",
  map_cannot_resolve: "Не удалось найти современное расположение для \"{name}\"",
  map_moved_via: "\"{name}\" перемещён через \"{query}\"",
  map_fix_failed: "Исправление AI не удалось: {error}",
  map_variant_created: "Вариант \"{name}\" создан",
  map_variant_duplicated: "Вариант дублирован",
  map_connection_removed: "Соединение удалено",
  map_added_layer: "Добавлено как слой",
  map_add_layer_failed: "Не удалось добавить слой",
  map_drawing_saved: "Рисунок слоя сохранён",
  map_save_drawing_failed: "Ошибка сохранения рисунка: {error}",
  map_ai_layer_generated: "Слой AI сгенерирован",
  map_ai_no_image: "Генерация не вернула изображение",
  map_ai_generation_failed: "Генерация AI не удалась: {error}",
  map_switched_to: "Переключено на {type}",
  map_linked_to: "Карта привязана к {name}",
  map_unlinked: "Карта отвязана от локации",
  map_placed_coords: "Размещено \"{label}\" на {lat}, {lng}",
  map_geocode_not_found: "Не найдено \"{address}\"",
  map_geocode_error: "Ошибка геокодирования: {error}",
  map_placed_via: "Размещено \"{name}\" через \"{query}\"",
  map_default_view_saved: "Вид по умолчанию сохранён ({lat}, {lng} z{zoom})",

  // ── import-utils ──
  imp_loading_world: "Импорт шаблона мира…",
  imp_invalid_world_file: "Неверный файл экспорта. Ожидается экспорт шаблона мира.",
  imp_sign_in_required: "Для импорта необходимо войти в систему.",
  imp_world_success: "Мир импортирован! {summary}",
  imp_failed: "Импорт не удался: {error}",
  imp_loading_game: "Импорт игрового экземпляра…",
  imp_invalid_game_file: "Неверный файл экспорта. Ожидается экспорт игрового экземпляра.",
  imp_game_success: "Игровой экземпляр импортирован! {messages} сообщений, {entities} сущностей",
  imp_resetting: "Сброс переопределений приключения…",
  imp_reset_success: "Переопределения приключения сброшены!",
  imp_reset_failed: "Сброс не удался: {error}",

  // ── export-utils ──
  exp_loading_world: "Экспорт шаблона мира…",
  exp_world_success: "Шаблон мира экспортирован!",
  exp_failed: "Экспорт не удался: {error}",
  exp_loading_player: "Экспорт данных игрока…",
  exp_player_success: "Данные игрока экспортированы!",
  exp_loading_game: "Экспорт игрового экземпляра…",
  exp_game_success: "Игровой экземпляр экспортирован!",

  // ── ImageGenerationDialog ──
  img_gen_disabled: "Генерация изображений сейчас отключена для вашего аккаунта. Свяжитесь с администратором для включения.",
  img_only_images: "Поддерживаются только файлы изображений",
  img_ref_uploaded: "Референсное изображение загружено",
  img_upload_failed: "Ошибка загрузки: {error}",
  img_draft_loaded: "Черновик загружен",
  img_draft_deleted: "Черновик удалён",
  img_drawing_saved: "Рисунок сохранён в медиагалерею",
  img_drawing_save_failed: "Ошибка сохранения рисунка: {error}",
  img_generated: "Изображение создано — проверьте и примите или попробуйте снова",
  // ── useWorldBuilderAgent ──
  wb_load_failed: "Ошибка загрузки мира: {error}",
  wb_create_failed: "Ошибка создания мира: {error}",
  wb_world_saved: "Мир успешно сохранён",
  wb_save_failed: "Ошибка сохранения: {error}",
  wb_credits_required: "Создание миров отключено — нужно не менее 50 кредитов",
  wb_agent_error: "Ошибка агента: {error}",
  // ── World ready celebration ──
  wb_world_ready_title: "🎉 Ваш мир готов!",
  wb_world_ready_desc: "Изучите кодекс, доработайте детали или отправляйтесь в приключение.",
  // ── useTTS ──
  tts_no_voice: "Голос нарратора не настроен (задайте в World Builder → Контекст)",
  tts_no_voice_short: "Голос нарратора не настроен",
  tts_downloaded: "Аудио загружено",
  tts_download_failed: "Ошибка загрузки аудио",
  // ── useFeatureFlags ──
  ff_locked: "Эта функция заблокирована администратором.",
  ff_update_failed: "Ошибка обновления флага функции",
  ff_lock_failed: "Ошибка обновления блокировки",
  ff_update_flags_failed: "Ошибка обновления флагов функций",
  // ── StyleReferencesPanel ──
  sref_added: "Стилевое изображение добавлено",
  sref_upload_failed: "Ошибка загрузки: {error}",
  sref_delete_failed: "Ошибка удаления",
  sref_removed: "Изображение удалено",
  // ── TrashManagerDialog ──
  trash_load_failed: "Ошибка загрузки корзины: {error}",
  trash_restored: "\"{name}\" восстановлен",
  trash_restore_failed: "Ошибка восстановления: {error}",
  trash_deleted: "\"{name}\" удалён навсегда",
  trash_delete_failed: "Ошибка удаления: {error}",
  trash_emptied: "Корзина очищена",
  trash_empty_failed: "Ошибка очистки корзины: {error}",
  // ── ChecklistPanel ──
  check_title_required: "Заголовок обязателен",
  check_updated: "Обновлено",
  check_added: "Добавлено",
  check_reset: "Список сброшен до настроек по умолчанию",
  check_all_done: "Все задачи уже выполнены!",
  check_queued: "В очередь добавлено {count} задач для ИИ (включая финальный обзор)",
  // ── ReportContentButton ──
  rep_sign_in_required: "Необходимо войти в систему, чтобы пожаловаться на контент.",
  rep_already_reported: "Вы уже пожаловались на этот контент. Наша команда рассматривает его.",
  rep_submitted: "Жалоба отправлена. Спасибо за помощь в поддержании безопасности AdVent.",
  rep_submit_failed: "Не удалось отправить жалобу",
  rep_try_later: "Пожалуйста, попробуйте позже.",
  // ── useMapVariants ──
  var_create_failed: "Ошибка создания варианта",
  var_update_failed: "Ошибка обновления варианта",
  var_delete_last: "Нельзя удалить последний вариант",
  var_delete_failed: "Ошибка удаления варианта",
  var_active_failed: "Ошибка активации варианта",
  // ── useMapUploads ──
  upl_map_uploaded: "Изображение карты загружено",
  upl_upload_failed: "Ошибка загрузки",
  upl_layer_added: "Слой добавлен",
  upl_layer_failed: "Ошибка загрузки слоя",
  upl_base_assigned: "Назначено базовой картой",
  upl_map_applied: "Изображение карты применено",
  upl_svg_applied: "SVG-карта применена",
  // ── Map editor / canvas placeholders ──
  map_node_label_placeholder: "Метка (напр. Замок Рок)",
  map_lat_placeholder: "Шир.",
  map_lng_placeholder: "Дол.",
  map_address_placeholder: "Адрес или название места...",
  map_search_nodes_placeholder: "Поиск узлов...",
  map_connection_desc_placeholder: "Опасный перевал...",
  map_search_nodes_places_placeholder: "Поиск узлов или мест...",
  map_location_name_placeholder: "Название локации...",
  map_voice_default_placeholder: "По умолчанию",
  map_search_locations_placeholder: "Поиск локаций...",
  map_node_desc_placeholder: "Краткое описание (необязательно)...",
  map_name_placeholder: "Карта мира",
  map_all_locations_filter: "Все локации (без фильтра)",
  map_node_image_url: "https://... или оставьте пустым для иконки",
  map_node_tags_placeholder: "напр. Территория фракции, Население...",
  map_style_json_url: "https://example.com/style.json",
  // ── useMapNodes ──
  node_create_failed: "Ошибка создания узла",
  node_delete_failed: "Ошибка удаления узла",
  node_save_partial: "Некоторые изменения не удалось сохранить",
  node_saved: "Карта сохранена",
  node_save_failed: "Ошибка сохранения карты: {error}",
  // ── MediaGallery ──
  media_img_generated: "Изображение создано!",
  media_generation_failed: "Ошибка генерации",
  media_delete_failed: "Удаление не удалось",
  media_update_failed: "Обновление не удалось",
  media_set_main: "Установлено как главное изображение",
  media_disconnect_failed: "Отключение не удалось",
  media_archived: "Изображение заархивировано (отвязано от объекта)",
  // ── EntityDetailDialog ──
  ent_updated: "Объект обновлён",
  ent_save_failed: "Сохранение не удалось: {error}",
  ent_trashed: '"{name}" перемещён в корзину',
  ent_delete_failed: "Удаление не удалось: {error}",
  ent_id_copied: "ID объекта скопирован",
  ent_deactivated: "{name} деактивирован",
  ent_activated: "{name} активирован",
  ent_dormant: "{name} теперь в спящем режиме",
  ent_active: "{name} теперь активен",
  // ── CreditWalletPanel ──
  cw_invalid_amount: "Введите корректную сумму",
  cw_balance_low: "Переводы кредитов отключены, если баланс ниже 100",
  cw_min_transfer: "Минимальная сумма перевода — 100 кредитов",
  cw_insufficient: "Недостаточно кредитов",
  cw_sent: "Отправлено {amount} кредитов!",
  // ── AgentEditor / AgentChatDialog / GroupChatDialog ──
  agent_needs_name: "Агент должен иметь имя",
  agent_saved: "Агент сохранён",
  agent_deleted: "Агент удалён",
  agent_chat_failed: "Ошибка чата: {error}",
  agent_group_failed: "Ошибка группового чата: {error}",
  // ── World builder misc components ──
  ctx_desc_update_failed: "Не удалось обновить описание",
  guidance_save_failed: "Сохранение не удалось: {error}",
  guidance_saved: "Руководство по изображениям сохранено",
  banner_save_failed: "Не удалось сохранить баннер: {error}",
  banner_removed: "Баннер удалён",
  banner_remove_failed: "Не удалось удалить баннер: {error}",
  icon_save_failed: "Не удалось сохранить иконку: {error}",
  icon_removed: "Иконка удалена",
  icon_remove_failed: "Не удалось удалить иконку: {error}",
  src_ref_add_failed: "Не удалось добавить ссылку",
  src_ref_deleted: "Ссылка удалена",
  src_ref_update_failed: "Обновление не удалось",
  pc_updated: "Персонаж обновлён",
  pc_created: "Персонаж создан",
  pc_needs_name: "Персонажу нужно имя",
  adv_inst_save_failed: "Не удалось сохранить изменения",
  auto_gen_complete: "Генерация мира завершена!",
  voice_saved: "Настройки голоса сохранены",
  gen_themes_generated: "Жанр и темы сгенерированы!",
  // ── useWorldMaps / useMapEntityActions ──
  wmap_create_failed: "Не удалось создать карту",
  wmap_update_failed: "Не удалось обновить карту",
  wmap_delete_failed: "Не удалось удалить карту",
  mea_create_failed: "Не удалось создать локацию: {error}",
  mea_gen_failed: "Генерация не удалась: {error}",
  wh_download_failed: "Загрузка не удалась",
  // ── Play components ──
  play_msg_updated: "Сообщение обновлено",
  play_snapshot_downloaded: "Снимок игры скачан",
  play_snapshot_failed: "Не удалось создать снимок",
  play_downloaded: "Скачано",
  // ── Map components ──
  map_lib_added: "Изображение карты добавлено в библиотеку",
  map_lib_removed: "Удалено из библиотеки",
  svg_traced: "SVG успешно трассирован",
  svg_lib_saved: "SVG сохранён в библиотеку",
  // ── MusicLibraryPanel / imagegen ──
  music_not_auth: "Не авторизован",
  music_group_update_failed: "Не удалось обновить группу",
  draft_started: "Новый черновик начат",
  draw_seed_saved: "Рисунок сохранён как seed и в медиагалерею",
  // ── Settings / Profile / Layout ──
  byok_saved: "Настройки BYOK сохранены",
  ai_enter_key: "Сначала введите API-ключ",
  app_bg_reset: "Фон сброшен до стандартного",
  custom_ai_saved: "Настройки AI сохранены!",
  custom_ai_save_failed: "Сохранение не удалось: {error}",
  custom_ai_name_placeholder: "Пользовательский AI",
  custom_ai_model_placeholder: "напр. gpt-4o, mistral-large и т.д.",
  custom_ai_endpoint_placeholder: "https://your-endpoint.com/v1/chat/completions",
  custom_ai_key_placeholder: "Введите API-ключ",
  custom_ai_instructions_placeholder: "Пользовательские инструкции для {label}…",
  settings_activity_filter_user: "Фильтр по user_id (необязательный UUID)…",
  settings_activity_search: "Поиск в журналах...",
  settings_credit_email: "user@example.com",
  settings_error_search: "Поиск ошибок...",
  settings_tool_search_query: "Введите поисковый запрос...",
  settings_tool_fetch_url: "URL для получения через proxy",
  settings_tool_franchise_slug: "Slug франшизы (напр. lotr, starwars, fallout)",
  mod_notes_placeholder: "Внутренние заметки об этом решении (видны только администраторам).",
  mod_report_details: "Добавьте всё, что поможет нам понять суть проблемы.",
  byok_api_key_placeholder: "Вставьте ваш API-ключ…",
  byok_account_name_placeholder: "Название аккаунта",
  byok_use_default: "Использовать по умолчанию",
  byok_endpoint_url: "https://api.openai.com/v1/chat/completions",
  ref_link_copied: "Реферальная ссылка скопирована!",
  copy_failed: "Не удалось скопировать",
  sign_out_failed: "Ошибка выхода из системы",
  admin_search_users: "Поиск по имени, email или ID...",
  // ── Community ──
  forum_topic_created: "Тема создана!",
  forum_topic_failed: "Ошибка: {error}",
};
